  (function () {
    var root = document.querySelector("[data-drsknn-v3]");
    if (!root || root.getAttribute("data-v3-init") === "1") return;
    root.setAttribute("data-v3-init", "1");
    document.body.classList.add("drsknn-v4-active-page");

    var state = {
      screen: 0,
      goals: [],
      goal: "",
      concerns: [],
      concern: "",
      priorities: [],
      priority: "",
      answers: {
        bothers: "",
        note_prompts: [],
        downtime: "little/no downtime",
        injectables: "not sure",
        identity: "not shared"
      }
    };
    var currentProofItems = [];
    var currentProofIndex = 0;
    var currentBnaCategory = "transformations";

    var screens = ["welcome", "goal", "outcome", "priority", "details", "result"];

    var labels = {
      skin: "Skin",
      face: "Face",
      body: "Body",
      hair: "Hair or scalp",
      unsure: "Not sure yet",
      healthier: "Look healthier",
      tired: "Look less tired",
      ageing: "Reduce ageing",
      skinOutcome: "Better skin",
      acne: "Acne or scarring",
      pigment: "Pigmentation or redness",
      definition: "Face definition",
      bodyOutcome: "Body shaping",
      hairOutcome: "Hair thinning",
      natural: "Natural result",
      downtime: "Little downtime",
      stronger: "Strongest suitable result",
      "no-injectables": "Avoid injectables",
      price: "Clear plan first",
      guided: "Guided by Dr Sknn"
    };

    var commonProof = [
      "https://ucarecdn.com/49ad3986-6f5a-48f0-bbf4-3e153769b81d/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_5_.jpeg",
      "https://ucarecdn.com/37a9e4a5-d424-4696-aaee-e228657089db/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_3_.jpeg",
      "https://ucarecdn.com/c3aeb948-a5f6-4796-8d48-c907641c7b8b/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_2_.jpeg",
      "https://ucarecdn.com/b258444d-121e-46c2-93f8-b43b26850b3e/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_22_.jpeg",
      "https://ucarecdn.com/f834c0ec-3648-4585-95ab-8ed4d937809b/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_27_.jpeg",
      "https://ucarecdn.com/85b351b1-ad1e-42d9-a52a-d82b3b583fcd/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_18_.jpeg",
      "https://ucarecdn.com/793fc160-07fe-4e9a-ba4d-c3e6b0f91701/-/format/auto/-/preview/3000x3000/-/quality/lighter/Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%202.jpeg"
    ];

    var representativeProof = {
      female: {
        general: [
          ["https://ucarecdn.com/37a9e4a5-d424-4696-aaee-e228657089db/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_3_.jpeg", "Female patient example", "Female proof"],
          ["https://ucarecdn.com/c3aeb948-a5f6-4796-8d48-c907641c7b8b/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_2_.jpeg", "Female patient example", "Female proof"],
          ["https://ucarecdn.com/49ad3986-6f5a-48f0-bbf4-3e153769b81d/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_5_.jpeg", "Female patient example", "Female proof"]
        ],
        "skin-rejuvenation": [
          ["https://ucarecdn.com/37a9e4a5-d424-4696-aaee-e228657089db/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_3_.jpeg", "Female skin-quality example", "Female proof"],
          ["https://ucarecdn.com/c3aeb948-a5f6-4796-8d48-c907641c7b8b/-/format/auto/-/preview/3000x3000/-/quality/lighter/Aesthetic%20Clinic%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_2_.jpeg", "Female skin-quality example", "Female proof"]
        ],
        "under-eye-treatment": [
          ["https://ucarecdn.com/dfa704b5-b711-45dc-a38e-22452a80fc7c/-/format/auto/-/preview/3000x3000/-/quality/lighter/UNDER%20EYE%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_9_.jpeg", "Female under-eye example", "Female proof"],
          ["https://ucarecdn.com/36b7eed0-0aa4-4ea5-885d-13901069755f/-/format/auto/-/preview/3000x3000/-/quality/lighter/Tear%20Trough%20Filler%20Wilmslow%20Dr%20Sknn%20_2_.jpeg", "Female under-eye example", "Female proof"]
        ],
        "anti-wrinkle": [
          ["https://ucarecdn.com/04d7577f-fcac-4a2b-b331-343ea1a9822a/-/format/auto/-/preview/3000x3000/-/quality/lighter/CROWS%20FEET%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20&%20After%20_2_.jpg", "Female anti-ageing example", "Female proof"]
        ],
        "jawline-fillers": [
          ["https://ucarecdn.com/40ca01fe-bbf4-46d7-93bf-960b13738bad/-/format/auto/-/preview/3000x3000/-/quality/lighter/Jowl%20Fillers%20Wilmslow,%20Cheshire%20Dr%20Sknn%20Aesthetic%20_3_.jpg", "Female profile example", "Female proof"]
        ]
      },
      male: {
        general: [
          ["https://cdn.shopify.com/s/files/1/0620/5020/5886/t/17/assets/origin-glass-laser-steven-day-30-rejuvenation-before-after-full-right-optimized.jpg?v=1780703420", "Male skin-rejuvenation example", "Male proof"],
          ["https://ucarecdn.com/3061b59f-62cf-4031-b241-e8fdeb8a8496/-/format/auto/-/preview/3000x3000/-/quality/lighter/HAIR%20LOSS%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_10_.jpeg", "Male hair and scalp example", "Male proof"],
          ["https://ucarecdn.com/973dfe7b-5f74-4c61-bc1a-72c710335603/-/format/auto/-/preview/3000x3000/-/quality/lighter/Mandibular%20Angle%20Filler%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg", "Male profile example", "Male proof"]
        ],
        "skin-rejuvenation": [
          ["https://cdn.shopify.com/s/files/1/0620/5020/5886/t/17/assets/origin-glass-laser-steven-day-30-rejuvenation-before-after-full-right-optimized.jpg?v=1780703420", "Male skin-rejuvenation example", "Male proof"],
          ["https://cdn.shopify.com/s/files/1/0620/5020/5886/t/17/assets/origin-glass-laser-steven-day-30-rejuvenation-before-after-front-optimized.jpg?v=1780703419", "Male skin-rejuvenation example", "Male proof"]
        ],
        "anti-wrinkle": [
          ["https://cdn.shopify.com/s/files/1/0620/5020/5886/t/17/assets/origin-glass-laser-steven-day-30-rejuvenation-before-after-full-right-optimized.jpg?v=1780703420", "Male ageing and skin-quality example", "Male proof"]
        ],
        "hair-regrowth": [
          ["https://ucarecdn.com/3061b59f-62cf-4031-b241-e8fdeb8a8496/-/format/auto/-/preview/3000x3000/-/quality/lighter/HAIR%20LOSS%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_10_.jpeg", "Male hair and scalp example", "Male proof"],
          ["https://ucarecdn.com/b21968e3-d2d4-4759-a10f-7bc51171b427/-/format/auto/-/preview/3000x3000/-/quality/lighter/HAIR%20LOSS%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20&%20After%20_13_.jpeg", "Male hair and scalp example", "Male proof"]
        ],
        "jawline-fillers": [
          ["https://ucarecdn.com/973dfe7b-5f74-4c61-bc1a-72c710335603/-/format/auto/-/preview/3000x3000/-/quality/lighter/Mandibular%20Angle%20Filler%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg", "Male profile example", "Male proof"]
        ]
      }
    };

    var heroProofFrames = [
      { src: commonProof[0], label: "Skin quality" },
      { src: commonProof[1], label: "Natural change" },
      { src: commonProof[3], label: "Freshness" },
      { src: representativeProof.male["skin-rejuvenation"][0][0], label: "Men's skin" },
      { src: commonProof[2], label: "Texture" },
      { src: representativeProof.female["under-eye-treatment"][0][0], label: "Under-eyes" },
      { src: representativeProof.male["jawline-fillers"][0][0], label: "Profile" },
      { src: commonProof[4], label: "Collagen" },
      { src: representativeProof.female["jawline-fillers"][0][0], label: "Definition" },
      { src: representativeProof.male["hair-regrowth"][0][0], label: "Hair" },
      { src: commonProof[5], label: "Real result" }
    ].filter(function (frame) {
      return frame && frame.src;
    });

    var trustDockHtml = [
      '<div class="drsknn-v3-trust-dock">',
      '<button class="drsknn-v3-trust-lead-card" type="button" data-v3-trust-toggle="doctor" aria-haspopup="dialog">',
      '<img src="https://cdn.shopify.com/s/files/1/0620/5020/5886/files/Dr_Eddie_Shaffu_-_Dr_Sknn_-_Medical_Lead_Dr_Sknn.jpg?v=1680776397" alt="" width="64" height="64" loading="eager" decoding="async">',
      '<span class="drsknn-v3-doctor-copy"><small>Medical lead</small><strong>Dr Eddie Shaffu</strong><span class="drsknn-v3-doctor-focus">GP · Aesthetic medicine · Skin ageing &amp; regenerative treatments</span><span class="drsknn-v3-doctor-credential-label">Credentials</span><span class="drsknn-v3-doctor-credentials" aria-label="Dr Eddie Shaffu credentials"><span>MB, BCh, BAO, LRCSl, LRCPl, NUI, MRCGP</span><span>Associate Member &mdash; British College of Aesthetic Medicine</span><span>MSc in Skin Ageing and Aesthetic Medicine</span></span></span>',
      '</button>',
      '<div class="drsknn-v3-trust-badges" aria-label="Dr Sknn trust signals">',
      '<button class="drsknn-v3-trust-review-card" type="button" data-v3-trust-toggle="google" aria-haspopup="dialog"><small>Google Reviews</small><strong><span data-v3-google-rating>5.0</span> <span class="drsknn-v3-inline-stars">★★★★★</span></strong><span data-v3-google-count>80+ live reviews</span><em>Personalised · caring · clear</em></button>',
      '<button class="drsknn-v3-trust-review-card" type="button" data-v3-trust-toggle="pabau" aria-haspopup="dialog"><small>Pabau Reviews</small><strong><span data-v3-pabau-rating>4.99/5</span> <span class="drsknn-v3-inline-stars">★★★★★</span></strong><span data-v3-pabau-count>183 verified reviews</span><em>Friendly · reassuring · guided</em></button>',
      '</div>',
      '<div class="drsknn-v3-slot-network drsknn-v3-slot-network-dock" aria-label="Next available Dr Sknn appointments">',
      '<button class="drsknn-v3-slot-bubble" type="button" data-v4-consultation-role="doctor"><small>Doctor consultation</small><strong>Check next doctor slot</strong><span>Doctor-led assessment</span><em>Book</em></button>',
      '<button class="drsknn-v3-slot-bubble" type="button" data-v4-consultation-role="nurse"><small>Nurse appointment</small><strong>Check next nurse slot</strong><span>Clinic assessment</span><em>Book</em></button>',
      '<button class="drsknn-v3-slot-bubble" type="button" data-v4-consultation-role="practitioner"><small>Qualified practitioner</small><strong>Check next practitioner slot</strong><span>Qualified practitioner</span><em>Book</em></button>',
      '</div>',
      '</div>'
    ].join("");

    var trustDetails = {
      doctor: {
        title: "Doctor-led clinic",
        subtitle: "Medical lead: Dr Eddie Shaffu",
        image: "https://cdn.shopify.com/s/files/1/0620/5020/5886/files/Dr_Eddie_Shaffu_-_Dr_Sknn_-_Medical_Lead_Dr_Sknn.jpg?v=1680776397",
        icon: "Dr",
        body: "Dr Eddie Shaffu is a highly accomplished General Practitioner and aesthetics specialist, with advanced training in skin ageing and aesthetic medicine alongside his GP credentials. He has undertaken extensive global training across leading institutions in the UK, USA, Canada, Malta, Spain and Bahrain, with a strong focus on reconstructive and aesthetic plastic surgery as well as clinical research.",
        points: [
          "MB, BCh, BAO, LRCSl, LRCPl, NUI, MRCGP",
          "Associate Member, British College of Aesthetic Medicine",
          "MSc in Skin Ageing and Aesthetic Medicine"
        ]
      },
      google: {
        title: "5.0 Google Reviews",
        subtitle: "80+ Google reviews · Real patients. Real results.",
        icon: "G",
        body: "Google Reviews help show real patient experience. We load the latest embeddable Google review text where Google allows it, with a direct link to the live Google profile for every review.",
        points: [
          "Live Google profile linked directly",
          "Concern-matched context",
          "Real patients. Real results."
        ]
      },
      pabau: {
        title: "4.99/5 Pabau Reviews",
        subtitle: "183 verified Pabau reviews",
        icon: "P",
        body: "Pabau feedback is used as a clinic patient trust source alongside consultation-first suitability and clear guidance before booking.",
        points: [
          "Patient-context trust",
          "Consultation-first approach",
          "Clear guidance first"
        ]
      }
    };

    var GOOGLE_PLACES_API_KEY = "AIzaSyDCX6AgsjLisxjIle7tYdxVhTQI0V5aXQI";
    var GOOGLE_PLACE_ID = "ChIJ-7JdE7NNekgRpxOzXg2xuUo";
    var GOOGLE_REVIEWS_URL = "https://www.google.com/maps/search/?api=1&query=Dr%20Sknn%20Wilmslow&query_place_id=" + GOOGLE_PLACE_ID;
    var PABAU_REVIEW_SLUG = "drsknn";
    var PABAU_REVIEWS_URL = "https://partner.pabau.com/reviews/" + PABAU_REVIEW_SLUG;
    var PABAU_GRAPHQL_URL = "https://api.pabau.com/v1/graphql";
    var BNA_STUDIO_URL = "/pages/before-after-pictures-dr-sknn";
    var activeTrustModalKey = "";
    var lastTrustTrigger = null;
    var reviewCallbacks = [];
    var pabauReviewCallbacks = [];
    var reviewState = {
      loading: false,
      loaded: false,
      failed: false,
      place: null
    };
    var pabauReviewState = {
      loading: false,
      loaded: false,
      failed: false,
      reviews: [],
      totalCount: 183,
      averageRating: 4.99
    };

    var reviewKeywords = {
      healthier: ["skin", "glow", "fresh", "natural", "consultation", "doctor"],
      tired: ["under eye", "tear trough", "tired", "eye", "natural", "filler"],
      ageing: ["wrinkle", "anti wrinkle", "ageing", "filler", "natural", "doctor"],
      skin: ["skin", "pores", "texture", "laser", "glow", "hydrafacial"],
      acne: ["acne", "scar", "scarring", "spots", "skin", "laser"],
      pigment: ["pigment", "redness", "rosacea", "skin", "ipl", "laser"],
      definition: ["jaw", "jawline", "chin", "cheek", "profile", "filler"],
      body: ["body", "onda", "fat", "tightening", "cellulite", "skin"],
      hair: ["hair", "scalp", "prp", "thinning", "beard"],
      unsure: ["consultation", "doctor", "help", "recommend", "safe", "natural"]
    };

    var bnaCategoryByConcern = {
      healthier: "skin-rejuvenation",
      tired: "under-eye-treatment",
      ageing: "anti-wrinkle",
      skin: "skin-rejuvenation",
      acne: "acne-treatment",
      pigment: "pigmentation",
      definition: "jawline-fillers",
      body: "body-contouring",
      hair: "hair-regrowth",
      unsure: "transformations"
    };

    var bnaCategoryLabels = {
      "transformations": "Transformations",
      "skin-rejuvenation": "Skin rejuvenation",
      "under-eye-treatment": "Under-eye treatment",
      "anti-wrinkle": "Anti-wrinkle",
      "acne-treatment": "Acne treatment",
      "acne-scarring": "Acne scarring",
      "pigmentation": "Pigmentation",
      "rosacea": "Rosacea",
      "redness": "Redness",
      "jawline-fillers": "Jawline fillers",
      "chin-fillers": "Chin fillers",
      "cheek-fillers": "Cheek fillers",
      "body-contouring": "Body contouring",
      "fat-reduction": "Fat reduction",
      "skin-tightening-body": "Body skin tightening",
      "hair-regrowth": "Hair regrowth",
      "scalp-treatment": "Scalp treatment",
      "hifu-facelift": "HIFU facelift",
      "neck-tightening": "Neck tightening"
    };

    var patientThemeDetails = {
      clear: {
        label: "Clear explanations",
        subtitle: "Patients often mention understanding the options before deciding.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["clear", "explain", "explained", "explanation", "understand", "information", "informative", "knowledge", "advice"],
        points: ["Clear options", "Explained before booking", "Guidance without pressure"]
      },
      natural: {
        label: "Natural-looking",
        subtitle: "Patients often look for subtle, considered, natural-looking guidance.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["natural", "subtle", "not overdone"],
        points: ["Natural-looking route", "Subtle change", "Face still feels like you"]
      },
      listened: {
        label: "Felt listened to",
        subtitle: "Patients often value feeling heard before a route is discussed.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["listen", "listened", "heard", "understood", "concern", "questions", "time"],
        points: ["Concerns heard", "Questions answered", "Time taken"]
      },
      reassuring: {
        label: "Reassuring",
        subtitle: "Patients often mention feeling calmer because the process is explained.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["reassur", "comfortable", "calm", "safe", "nervous", "put me at ease", "confidence"],
        points: ["Reassuring tone", "Calm process", "Suitability first"]
      },
      doctor: {
        label: "Doctor-led advice",
        subtitle: "Patients often value advice from a medically-led clinic before choosing a route.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["doctor", "dr", "eddie", "medical", "professional", "knowledge", "expert", "safe"],
        points: ["Medical lead", "Suitability checked", "Doctor-led planning"]
      },
      "not-rushed": {
        label: "Not rushed",
        subtitle: "Patients often value time to talk through goals and preferences.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["rushed", "time", "patient", "thorough", "pressure", "no pressure", "took time", "takes as long"],
        points: ["Time to discuss", "No pressure", "Thorough consultation"]
      },
      honest: {
        label: "Honest guidance",
        subtitle: "Patients often mention clear guidance on what is and is not worth doing.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["honest", "trust", "advice", "recommend", "recommended", "needed", "not needed", "transparent"],
        points: ["Honest advice", "No unnecessary route", "Transparent recommendation"]
      },
      professional: {
        label: "Professional",
        subtitle: "Patients often mention professionalism, clinical standards and confidence in the team.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["professional", "clinic", "team", "service", "knowledge", "expert", "clean", "experience"],
        points: ["Professional setting", "Clinical standards", "Experienced team"]
      },
      personalised: {
        label: "Personalised plan",
        subtitle: "Patients often value a plan shaped around their concern rather than a fixed menu.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["personal", "personalised", "tailor", "bespoke", "plan", "individual", "recommend"],
        points: ["Personal route", "Concern-led plan", "Options narrowed"]
      },
      confidence: {
        label: "Confidence",
        subtitle: "Patients often describe feeling more confident after clear, supportive guidance.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["confidence", "confident", "happy", "pleased", "comfortable", "amazing", "recommend"],
        points: ["Confidence to decide", "Comfort in the process", "Clear next step"]
      },
      caring: {
        label: "Caring team",
        subtitle: "Patients often mention kindness, care and supportive communication.",
        source: "Google and Pabau patient feedback themes",
        keywords: ["care", "caring", "kind", "friendly", "lovely", "support", "team", "welcoming"],
        points: ["Caring team", "Friendly communication", "Supportive experience"]
      }
    };

    var paths = {
      healthier: {
        label: "Healthier, fresher looking skin",
        intro: "We would usually start with skin quality, hydration, tone, barrier strength and whether a simple maintenance plan is enough before considering stronger treatments.",
        assess: ["Skin quality", "Hydration", "Texture", "Tone", "Barrier", "Lifestyle triggers"],
        treatments: [
          ["Consultation / skin analysis", "First step to check suitability and map priorities."],
          ["HydraFacial / Hydra + Skin", "For freshening, cleansing, hydration and glow."],
          ["Dermalux LED", "For inflammation, recovery, acne support and barrier repair."],
          ["Personalised medical skincare", "For daily correction between clinic visits."],
          ["Skin boosters or polynucleotides", "If injectable regenerative support is appropriate."]
        ],
        proofTitle: "Skin quality and full-face journeys",
        proof: commonProof,
        reviews: [
          ["Clarity before treatment", "Patients often value being told what is and is not needed."],
          ["Natural-looking results", "The starting point is usually freshness, not changing the face."],
          ["Ongoing care", "Maintenance plans can be built gradually instead of doing everything at once."]
        ],
        prices: [
          ["Consultation / skin analysis", "Free consultation · &pound;50 reservation fee", "Reservation secures your appointment."],
          ["Dermalux LED", "from &pound;45", "Stand-alone or add-on sessions."],
          ["HydraFacial / Perk", "from &pound;85", "Entry glow and targeted areas."],
          ["Personalised medical skincare", "from &pound;136/month", "Confirmed after skin analysis."]
        ],
        upsell: [
          ["Serum Lift / microneedling", "For texture, pores and collagen support if you want more than glow."],
          ["IPL or peels", "Useful when uneven tone, pigmentation or redness is also present."],
          ["Injectable regenerative options", "Skin boosters, polynucleotides, PRP or exosomes can be discussed if relevant."]
        ]
      },
      tired: {
        label: "A less tired, more rested face",
        intro: "We would usually separate true under-eye hollowing from pigment, puffiness, skin quality, volume loss and whole-face fatigue before recommending a route.",
        assess: ["Under-eye hollowing", "Dark circles", "Puffiness", "Volume loss", "Skin quality", "Sleep/stress pattern"],
        treatments: [
          ["Consultation / facial assessment", "Needed because tiredness can come from different layers."],
          ["Skin boosters / M-HA 10 / NCTF", "For hydration, crepiness and tired skin quality."],
          ["Polynucleotides or PRP", "For regenerative under-eye and skin quality support."],
          ["Tear trough filler", "Only if hollowing and anatomy make it suitable."],
          ["Anti-wrinkle injections", "For expression lines or brow-related tiredness."]
        ],
        proofTitle: "Under-eye and rejuvenation examples",
        proof: [
          "https://ucarecdn.com/36b7eed0-0aa4-4ea5-885d-13901069755f/-/format/auto/-/preview/3000x3000/-/quality/lighter/Tear%20Trough%20Filler%20Wilmslow%20Dr%20Sknn%20_2_.jpeg",
          "https://ucarecdn.com/c5a42408-0ada-4fab-889c-9d4b28fe6692/-/format/auto/-/preview/3000x3000/-/quality/lighter/tear%20trough%20filler%20Wilmslow,%20Cheshire.jpg",
          "https://ucarecdn.com/c48f1a60-0f44-4870-9137-c7459b0eeb17/-/format/auto/-/preview/3000x3000/-/quality/lighter/tear%20trough%20fillers%20Dr%20Sknn%20Before%20%26%20After%20Picture.jpg"
        ],
        reviews: [
          ["Under-eye suitability", "Patients often need help understanding whether filler, regenerative treatment or skin work is safest."],
          ["Subtle changes", "The aim is a rested look rather than an obvious treatment look."],
          ["Combination plans", "Tiredness can improve when skin, volume and muscle movement are considered together."]
        ],
        prices: [
          ["Consultation / assessment", "Free consultation · &pound;50 reservation fee", "Suitability checked first."],
          ["NCTF / HA skin quality options", "from &pound;167", "Typical starting options vary by area."],
          ["Polynucleotides", "from &pound;167", "Under-eye and skin protocols available."],
          ["Tear trough filler", "from &pound;285", "Only if anatomy is suitable."]
        ],
        upsell: [
          ["Skin glow treatments", "HydraFacial, LED or peels can support brightness around bigger plans."],
          ["Full-face balancing", "Cheek or mid-face support may be more appropriate than treating the under-eye alone."],
          ["Medical skincare", "Daily pigment, hydration and barrier support can protect results."]
        ]
      },
      ageing: {
        label: "Ageing, lines and collagen change",
        intro: "We would usually look at movement lines, collagen loss, laxity, volume loss, skin texture and neck changes before choosing a staged plan.",
        assess: ["Movement lines", "Collagen loss", "Volume loss", "Skin laxity", "Neck", "Texture"],
        treatments: [
          ["Anti-wrinkle injections", "For dynamic lines and expression-related ageing."],
          ["Dermal filler", "For carefully selected volume and structure support."],
          ["Polynucleotides / PRP / exosomes", "For regenerative skin quality and collagen support."],
          ["HIFU or ONDA tightening", "For lifting, firming and non-surgical tightening."],
          ["CO2 laser / microneedling", "For texture, lines and resurfacing when suitable."]
        ],
        proofTitle: "Anti-ageing and rejuvenation examples",
        proof: [
          "https://ucarecdn.com/4b98070e-484d-4c03-bf9f-810a57aebdeb/-/format/auto/-/preview/3000x3000/-/quality/lighter/anti-wrinkle%20injections%20Forehead%20Wilmslow%20Dr%20Sknn%20_5_.jpg",
          "https://ucarecdn.com/f4761794-7e18-4e9f-9257-46edde0b524a/-/format/auto/-/preview/3000x3000/-/quality/lighter/hifu%20NON-Surgical%20Face%20Lift%20single%20session%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg",
          "https://ucarecdn.com/0f462e31-f710-4271-aa0a-4bbb1e8ab399/-/format/auto/-/preview/3000x3000/-/quality/lighter/ONDA%20non%20surgical%20%20neck%20tightening%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpeg",
          "https://cdn.shopify.com/s/files/1/0620/5020/5886/files/origin-laser-skin-rejuvenation-before-and-after-3-months-follow-up-after-3-treatments-01.png?v=1775782925",
          "https://cdn.shopify.com/s/files/1/0620/5020/5886/files/origin-laser-skin-rejuvenation-before-and-after-3-months-follow-up-after-4-treatments-03.png?v=1775782938"
        ],
        reviews: [
          ["Doctor-led safety", "Patients often want ageing treatment without being pushed into everything at once."],
          ["Natural expression", "Movement can be softened while keeping the face recognisable."],
          ["Long-term planning", "Ageing plans work best when collagen, skin and structure are staged."]
        ],
        prices: [
          ["Anti-wrinkle injections", "from &pound;176", "Area and prescriber dependent."],
          ["Dermal filler", "from &pound;285", "Confirmed by area and volume needed."],
          ["Polynucleotides", "from &pound;167", "Area and protocol dependent."],
          ["HIFU", "from &pound;140", "Area and intensity dependent."]
        ],
        upsell: [
          ["Neck and jawline", "Often worth assessing alongside facial ageing."],
          ["Skin maintenance", "LED, HydraFacial and medical skincare help protect more advanced work."],
          ["Regenerative support", "PRP, exosomes or polynucleotides may suit gradual collagen-focused goals."]
        ]
      },
      skin: {
        label: "Better skin texture, glow and pores",
        intro: "We would usually start by checking congestion, pores, texture, sensitivity, pigmentation, redness and your current routine.",
        assess: ["Pores", "Texture", "Congestion", "Barrier", "Pigment", "Redness"],
        treatments: [
          ["Skin analysis", "Clarifies what your skin actually needs."],
          ["Chemical peels", "For clarity, tone, congestion and dullness."],
          ["Microneedling / Dr Sknn Serum Lift", "For pores, texture and collagen stimulation."],
          ["CO2 laser", "For deeper texture, scars and resurfacing when suitable."],
          ["Universkin / personalised skincare", "For daily active support."]
        ],
        proofTitle: "Skin rejuvenation and texture examples",
        proof: [
          "https://ucarecdn.com/4e7b6ea6-ef63-43e7-b8b9-27b0b59cc273/-/format/auto/-/preview/3000x3000/-/quality/lighter/Skin%20Rejuvenation%20co2%20Fractional%20Ablative%20Laser%20Wilmslow,%20Cheshire%20Dr%20Sknn%20Aesthetic%20_16_.jpg",
          "https://ucarecdn.com/8c2b1a63-e96b-4276-9225-7a1261f52406/-/format/auto/-/preview/3000x3000/-/quality/lighter/Open%20Pores%20co2%20Fractional%20Ablative%20Laser%20Wilmslow,%20Cheshire%20Dr%20Sknn%20Aesthetic%20_3_.jpg",
          "https://ucarecdn.com/6e87d6ad-d402-49a9-b7fd-601e235152dc/-/format/auto/-/preview/3000x3000/-/quality/lighter/OPEN%20PORES%20TREATMENT%20Wilmslow%20Dr%20Sknn.jpeg"
        ],
        reviews: [
          ["Personalisation", "Patients often need help choosing between peels, microneedling, laser and skincare."],
          ["Barrier respect", "Sensitive skin needs a staged plan, not aggressive treatment first."],
          ["Maintenance", "Homecare and in-clinic treatments work better when they are aligned."]
        ],
        prices: [
          ["Chemical peels", "from &pound;68", "Depth and active choice vary."],
          ["Dermalux LED", "from &pound;45", "Useful as support or add-on."],
          ["Microneedling / serum infusion", "from &pound;100", "Protocol dependent."],
          ["CO2 laser", "from &pound;225", "Area and intensity dependent."]
        ],
        upsell: [
          ["Pigmentation / redness mapping", "Often appears alongside texture concerns."],
          ["Personalised serum programme", "A daily actives plan can support clinic results."],
          ["HydraFacial maintenance", "Useful between stronger treatments."]
        ]
      },
      acne: {
        label: "Acne, scarring and post-acne marks",
        intro: "We would usually separate active acne, scarring, post-inflammatory marks, redness, oiliness and barrier damage before planning treatment.",
        assess: ["Active acne", "Acne scarring", "Post-acne marks", "Oiliness", "Pores", "Barrier"],
        treatments: [
          ["Consultation / skin analysis", "To separate active acne from scarring and marks."],
          ["Medical skincare", "For acne control, barrier and pigment support."],
          ["Microneedling", "For texture and collagen remodelling when suitable."],
          ["CO2 laser", "For deeper acne scarring and resurfacing."],
          ["PRP / exosomes / LED", "For recovery, inflammation and regenerative support."]
        ],
        proofTitle: "Acne and acne scarring examples",
        proof: [
          "https://ucarecdn.com/fe191ab0-5071-43a7-9c16-94414d4198a2/-/format/auto/-/preview/3000x3000/-/quality/lighter/Acne%20Scarring%20Treatment%20Wilmslow%20Dr%20Sknn%20Cheshire%20Before%20%26%20After.jpg",
          "https://ucarecdn.com/7afc0969-3e96-45c4-aa5f-627b281c093b/-/format/auto/-/preview/3000x3000/-/quality/lighter/ACNE%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_3_.jpeg",
          "https://ucarecdn.com/e3b3367e-1d27-470e-8672-632ef5edfc9d/-/format/auto/-/preview/3000x3000/-/quality/lighter/BACK%20ACNE%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_2_.jpeg",
          "https://cdn.shopify.com/s/files/1/0620/5020/5886/files/origin-laser-acne-scarring-before-and-after-1-month-follow-up-after-1-treatment-01.png?v=1775782848",
          "https://cdn.shopify.com/s/files/1/0620/5020/5886/files/origin-laser-acne-scarring-before-and-after-4-months-follow-up-after-4-treatments-03.png?v=1775782860"
        ],
        reviews: [
          ["Realistic staging", "Acne and scarring usually need a sequence rather than one treatment."],
          ["Inflammation control", "Active acne needs calming before aggressive resurfacing."],
          ["Confidence", "Patients often value visible skin change with clear guidance on expectations."]
        ],
        prices: [
          ["Consultation / skin analysis", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Dermalux LED", "from &pound;45", "Acne and inflammation support."],
          ["Microneedling / serum infusion", "from &pound;100", "Texture protocol dependent."],
          ["CO2 laser", "from &pound;225", "For scarring and resurfacing."]
        ],
        upsell: [
          ["Post-acne pigmentation", "Often needs pigment support alongside scar work."],
          ["Medical skincare", "Keeps active acne controlled between clinic visits."],
          ["Back or body acne", "Can be reviewed if relevant, including LED, peels and body skin treatments."]
        ]
      },
      pigment: {
        label: "Pigmentation, redness or uneven tone",
        intro: "We would usually identify whether the main issue is pigment, melasma, sun damage, redness, rosacea, veins, inflammation or post-acne marks.",
        assess: ["Pigmentation", "Melasma", "Redness", "Rosacea", "Thread veins", "Sensitivity"],
        treatments: [
          ["Skin analysis", "To distinguish pigment from vascular redness."],
          ["IPL / IllumiFacial", "For selected pigment, redness and vascular concerns."],
          ["Chemical peels", "For tone, pigment and surface renewal."],
          ["Medical skincare", "Daily active support for pigment and redness."],
          ["LED", "For calming inflammation and supporting repair."]
        ],
        proofTitle: "Pigmentation, rosacea and redness examples",
        proof: [
          "https://ucarecdn.com/1c599b34-da62-4769-a0db-6c5bc79babf5/-/format/auto/-/preview/3000x3000/-/quality/lighter/IPL%20Pigmentation%20Treatment%20Wilmslow,%20Cheshire%20Dr%20Sknn%20Aesthetic.jpg",
          "https://ucarecdn.com/32c49c9b-9357-425c-bafd-82da70264a8c/-/format/auto/-/preview/3000x3000/-/quality/lighter/IPL%20Rosacea%20Treatment%20Wilmslow,%20Cheshire%20Dr%20Sknn%20Aesthetic.jpg",
          "https://ucarecdn.com/e6d743f5-e01a-46c0-86a2-6545da9babdf/-/format/auto/-/preview/3000x3000/-/quality/lighter/Rosacea%20Treatment%20Wilmslow,%20Cheshire.jpg"
        ],
        reviews: [
          ["Correct diagnosis", "Pigment and redness need different treatment choices."],
          ["SPF and homecare", "Long-term control depends on routine as well as devices."],
          ["Sensitive skin", "Reactive skin benefits from a cautious staged approach."]
        ],
        prices: [
          ["IPL / IllumiFacial", "from &pound;90", "Area and concern dependent."],
          ["Chemical peels", "from &pound;68", "Depth and active choice vary."],
          ["Dermalux LED", "from &pound;45", "Calming and recovery support."],
          ["Personalised skincare", "from &pound;136/month", "Confirmed after analysis."]
        ],
        upsell: [
          ["Skin barrier work", "Redness often improves when barrier and inflammation are supported."],
          ["CO2 or microneedling", "May be suitable later if texture or scarring is also present."],
          ["Hand, chest or neck pigment", "Can be assessed alongside the face if relevant."]
        ]
      },
      definition: {
        label: "Face definition and profile balance",
        intro: "We would usually assess chin, jawline, cheek support, masseter size, submental fullness, skin laxity and facial proportions before suggesting treatment.",
        assess: ["Jawline", "Chin", "Cheeks", "Profile", "Masseter", "Neck/submental area"],
        treatments: [
          ["Facial assessment", "Needed to balance profile, safety and proportions."],
          ["Dermal filler", "For chin, cheek or jawline support when suitable."],
          ["Anti-wrinkle / masseter treatment", "For jawline slimming or TMJ-type concerns where appropriate."],
          ["ONDA neck / submental", "For selected localised fullness and tightening."],
          ["HIFU / tightening", "For lower-face laxity and contour support."]
        ],
        proofTitle: "Jawline, chin and profile examples",
        proof: [
          "https://ucarecdn.com/bf313e2e-7a61-4cd2-86ad-1caa1c5aba44/-/format/auto/-/preview/3000x3000/-/quality/lighter/Jawline%20Fillers%20Wilmslow,%20Cheshire.jpg",
          "https://ucarecdn.com/973dfe7b-5f74-4c61-bc1a-72c710335603/-/format/auto/-/preview/3000x3000/-/quality/lighter/Mandibular%20Angle%20Filler%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg",
          "https://ucarecdn.com/9ccb53a3-23da-4540-8afb-2bfde8d92f1e/-/format/auto/-/preview/3000x3000/-/quality/lighter/Chin%20Filler%20DERMAL%20FILLERS%20Wilmslow%20Dr%20Sknn%20Cheshire%20Before%20%26%20After.jpeg"
        ],
        reviews: [
          ["Facial balance", "Definition can come from structure, slimming, tightening or skin support."],
          ["Safety first", "Filler suitability and anatomy are assessed carefully before treatment."],
          ["Natural shape", "The goal is proportion and definition, not an overdone look."]
        ],
        prices: [
          ["Dermal filler", "from &pound;285", "Area and volume dependent."],
          ["Anti-wrinkle / masseter", "from &pound;176", "Dose and area dependent."],
          ["ONDA neck / jawline", "from &pound;145", "Area and course dependent."],
          ["HIFU", "from &pound;140", "Area and intensity dependent."]
        ],
        upsell: [
          ["Skin tightening", "Jawline definition can improve with firming as well as structure."],
          ["Neck assessment", "The neck/submental area often affects the jawline result."],
          ["Skin quality", "Texture and glow can make definition look cleaner."]
        ]
      },
      body: {
        label: "Body shaping, fat reduction or tightening",
        intro: "We would usually map the exact body area, tissue thickness, skin laxity, cellulite, treatment tolerance and whether a course is realistic.",
        assess: ["Localised fat", "Skin laxity", "Cellulite", "Treatment area", "Course length", "Lifestyle"],
        treatments: [
          ["ONDA fat reduction", "For selected localised fat pockets."],
          ["ONDA body sculpting", "For contouring abdomen, flanks, thighs and similar areas."],
          ["ONDA skin tightening", "For laxity on stomach, arms, thighs and neck."],
          ["Cellulite smoothing", "For dimpling and uneven texture where suitable."],
          ["Body skin treatments", "For scars, stretch marks, pigmentation or texture."]
        ],
        proofTitle: "ONDA body and tightening examples",
        proof: [
          "https://ucarecdn.com/173850de-cbdf-4155-b05e-b12c7da97d36/-/format/auto/-/preview/3000x3000/-/quality/lighter/ONDA%20Body%20contouring%20Non-Surgical%20BBL%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg",
          "https://ucarecdn.com/7adcdfee-ecf0-409d-9158-e51fc8701c1a/-/format/auto/-/preview/3000x3000/-/quality/lighter/ONDA%20non%20surgical%20skin%20tightening%20Wilmslow%20Dr%20Sknn%20Cheshire%20Before%20%26%20After.jpg",
          "https://ucarecdn.com/f5de792e-ccb3-4fb4-aa04-8f0c967e2893/-/format/auto/-/preview/3000x3000/-/quality/lighter/ONDA%20non%20surgical%20cellulite%20treatment%20Before%20%26%20After%20Wilmslow,%20Cheshire.jpg"
        ],
        reviews: [
          ["Realistic courses", "Body treatments usually work as a plan, not a single promise."],
          ["Area selection", "The exact area and tissue type decide whether ONDA is suitable."],
          ["Combination thinking", "Fat reduction, sculpting and tightening can be discussed together."]
        ],
        prices: [
          ["ONDA single area", "from &pound;145", "Area and course dependent."],
          ["ONDA larger areas", "from &pound;195", "Confirmed after assessment."],
          ["Body skin treatments", "from &pound;225", "Scars, stretch marks or resurfacing."],
          ["Combination plans", "confirmed after assessment", "Built around area and goals."]
        ],
        upsell: [
          ["Skin tightening", "Often relevant after fat reduction or weight change."],
          ["Cellulite smoothing", "Can be discussed if texture is a concern."],
          ["Laser hair removal", "Popular alongside body planning for convenience."]
        ]
      },
      hair: {
        label: "Hair thinning or scalp health",
        intro: "We would usually look at pattern, timeline, scalp health, shedding, medical history, current products and whether regenerative support is appropriate.",
        assess: ["Hair pattern", "Timeline", "Scalp health", "Shedding", "Density", "Medical triggers"],
        treatments: [
          ["Hair and scalp consultation", "To assess pattern, triggers and suitability."],
          ["PRP scalp", "Regenerative support for selected hair thinning concerns."],
          ["Polynucleotides / exosomes", "May be discussed for scalp and hair support."],
          ["Scalp treatments", "For scalp health, cleansing, inflammation or flaking."],
          ["At-home care plan", "To support consistency between visits."]
        ],
        proofTitle: "Hair and scalp examples",
        proof: [
          "https://ucarecdn.com/22fc9770-aee5-4063-adea-34d1758ced26/-/format/auto/-/preview/3000x3000/-/quality/lighter/HAIR%20LOSS%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_3_%203.jpeg",
          "https://ucarecdn.com/3061b59f-62cf-4031-b241-e8fdeb8a8496/-/format/auto/-/preview/3000x3000/-/quality/lighter/HAIR%20LOSS%20TREATMENT%20Wilmslow%20Transformation%20Dr%20Sknn%20Cheshire%20Before%20%26%20After%20_10_.jpeg",
          "https://ucarecdn.com/854983a5-4d14-452e-9360-1d68d9e0f47e/-/format/auto/-/preview/3000x3000/-/quality/lighter/SCALP%20TREATMENT%20Wilmslow%20Dr%20Sknn.jpeg"
        ],
        reviews: [
          ["Discreet planning", "Hair concerns often need privacy, consistency and realistic timelines."],
          ["Scalp plus hair", "Scalp health can affect how well a plan performs."],
          ["Male and female patterns", "Pattern and medical context shape the route."]
        ],
        prices: [
          ["Hair / scalp consultation", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["PRP scalp", "from &pound;290", "Protocol dependent."],
          ["Polynucleotides scalp", "from &pound;195", "Area and protocol dependent."],
          ["HydraFacial scalp", "from &pound;180", "Scalp treatment option."]
        ],
        upsell: [
          ["Laser hair removal", "For unwanted hair or beard shaping where relevant."],
          ["Scalp health treatments", "Useful when flaking, irritation or oiliness is part of the picture."],
          ["Skin glow or anti-ageing", "Can be discussed in the same visit if it matters to your goals."]
        ],
        male: true
      },
      unsure: {
        label: "A consultation-first starting point",
        intro: "If you are unsure, we would keep the starting point broad: understand your priorities, check safety and show only the options that fit.",
        assess: ["Your main concern", "Medical suitability", "Skin quality", "Face/body/hair priority", "Budget", "Downtime"],
        treatments: [
          ["Consultation", "The safest first step when you do not know what to book."],
          ["Skin analysis", "Useful if skin quality, acne, redness or pigmentation may be involved."],
          ["Facial assessment", "Useful for tiredness, ageing or definition questions."],
          ["Treatment pathway", "We build a staged plan rather than asking you to choose alone."]
        ],
        proofTitle: "Relevant examples after we know your concern",
        proof: commonProof,
        reviews: [
          ["No pressure", "Patients often start unsure and value being guided clearly."],
          ["Suitable options only", "The consultation narrows the menu to what makes sense."],
          ["Clear guidance", "Suitability and route options are discussed before treatment."]
        ],
        prices: [
          ["Consultation", "Free consultation · &pound;50 reservation fee", "Best starting point."],
          ["Skin analysis", "Free to start", "For skin-led journeys."],
          ["Starting treatments", "from &pound;45", "Depends on selected pathway."],
          ["Combination plans", "confirmed after assessment", "Built around goals and suitability."]
        ],
        upsell: [
          ["Skin, face, body and hair review", "We can discuss more than one area if relevant."],
          ["Male pathway", "Available for hair, body, jawline, beard and skin goals."],
          ["Maintenance", "Some goals are best solved with a simple ongoing plan."]
        ]
      }
    };

    var v4PathCopy = {
      healthier: {
        label: "Healthier, fresher looking skin",
        intro: "We would usually start by checking skin quality, hydration, tone, barrier strength and whether a simple maintenance route is enough before stronger options are discussed.",
        assess: ["Skin quality", "Hydration", "Texture", "Tone", "Barrier", "Lifestyle triggers"],
        treatments: [
          ["Doctor-led skin assessment", "Clarifies what is worth doing first and what can wait."],
          ["Skin health pathway", "For glow, hydration, congestion, barrier support and maintenance."],
          ["Calming and recovery support", "For inflammation, redness, sensitivity and repair."],
          ["At-home active plan", "Keeps clinic results consistent between visits."],
          ["Regenerative skin quality route", "Only discussed when it fits your goals, comfort and suitability."]
        ],
        proofTitle: "Skin quality and full-face journeys",
        reviews: [
          ["Clarity first", "Patients often value being told what is and is not needed."],
          ["Natural-looking change", "The starting point is usually freshness, not changing the face."],
          ["Ongoing care", "Plans can be built gradually instead of doing everything at once."]
        ],
        prices: [
          ["Doctor-led consultation", "Free consultation · &pound;50 reservation fee", "Reservation secures your appointment."],
          ["Entry skin support", "from &pound;45", "For low-disruption skin health routes."],
          ["Skin health pathway", "from &pound;85", "Confirmed after assessment."],
          ["Personalised homecare route", "from &pound;136/month", "Only where it fits your skin."]
        ],
        upsell: [
          ["Texture and pore support", "Useful when glow is not the only concern."],
          ["Tone and redness mapping", "Helpful if uneven colour or sensitivity is also present."],
          ["Collagen and regeneration", "Can be discussed if you want a more progressive route."]
        ]
      },
      tired: {
        label: "A less tired, more rested face",
        intro: "We would usually separate under-eye hollowing, pigment, puffiness, skin quality, volume loss and whole-face fatigue before recommending any route.",
        assess: ["Under-eye hollowing", "Dark circles", "Puffiness", "Volume balance", "Skin quality", "Sleep/stress pattern"],
        treatments: [
          ["Facial assessment", "Needed because tiredness can come from different layers."],
          ["Skin quality pathway", "For crepiness, dullness, hydration and fine texture."],
          ["Regenerative support route", "For selected under-eye and skin quality concerns."],
          ["Structure and volume assessment", "Only if anatomy and suitability support it."],
          ["Expression and brow assessment", "Where movement is adding to the tired look."]
        ],
        proofTitle: "Under-eye and rejuvenation examples",
        reviews: [
          ["Suitability before treatment", "Patients often need help understanding what is safest around the eyes."],
          ["Subtle changes", "The aim is a rested look rather than an obvious treatment look."],
          ["Combination thinking", "Tiredness can improve when skin, volume and movement are considered together."]
        ],
        prices: [
          ["Doctor-led assessment", "Free consultation · &pound;50 reservation fee", "Suitability checked first."],
          ["Skin quality route", "from &pound;145", "Area and protocol dependent."],
          ["Regenerative route", "from &pound;167", "Only where suitable."],
          ["Structure route", "from &pound;285", "Confirmed after facial assessment."]
        ],
        upsell: [
          ["Brightness and glow support", "Useful when dullness contributes to tiredness."],
          ["Whole-face balance", "Sometimes the cheek or mid-face matters more than the under-eye alone."],
          ["At-home maintenance", "Daily skin support can protect and extend results."]
        ]
      },
      ageing: {
        label: "Ageing, lines and collagen change",
        intro: "We would usually look at movement lines, collagen loss, laxity, volume change, texture and neck changes before choosing a staged plan.",
        assess: ["Movement lines", "Collagen loss", "Volume change", "Skin laxity", "Neck", "Texture"],
        treatments: [
          ["Ageing pattern assessment", "Identifies whether skin, structure, movement or laxity is leading."],
          ["Movement-softening route", "For expression-related lines where appropriate."],
          ["Structure and balance route", "For carefully selected volume and contour support."],
          ["Collagen and skin quality route", "For gradual firming, repair and resilience."],
          ["Tightening and resurfacing route", "For laxity or texture where downtime and suitability fit."]
        ],
        proofTitle: "Ageing and rejuvenation examples",
        reviews: [
          ["Doctor-led safety", "Patients often want ageing treatment without being pushed into everything at once."],
          ["Natural expression", "The goal is softening and freshness while keeping the face recognisable."],
          ["Long-term planning", "Ageing plans work best when collagen, skin and structure are staged."]
        ],
        prices: [
          ["Doctor-led assessment", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Movement route", "from &pound;176", "Area and prescriber dependent."],
          ["Structure route", "from &pound;285", "Area and volume dependent."],
          ["Collagen or tightening route", "from &pound;140", "Protocol dependent."]
        ],
        upsell: [
          ["Neck and jawline review", "Often worth assessing alongside facial ageing."],
          ["Skin maintenance", "Low-disruption support can protect more advanced work."],
          ["Regenerative planning", "May suit gradual collagen-focused goals."]
        ]
      },
      skin: {
        label: "Better skin texture, glow and pores",
        intro: "We would usually start by checking congestion, pores, texture, sensitivity, pigmentation, redness and your current routine.",
        assess: ["Pores", "Texture", "Congestion", "Barrier", "Pigment", "Redness"],
        treatments: [
          ["Skin analysis", "Clarifies what your skin actually needs."],
          ["Clarity and glow pathway", "For dullness, congestion, pores and tone."],
          ["Texture and collagen pathway", "For visible pores, roughness and gradual remodelling."],
          ["Advanced resurfacing pathway", "Only where the skin and downtime preference make it suitable."],
          ["Personalised homecare route", "For daily active support between visits."]
        ],
        proofTitle: "Skin texture and rejuvenation examples",
        reviews: [
          ["Personalisation", "Patients often need help choosing between gentle and stronger skin routes."],
          ["Barrier respect", "Sensitive skin needs a staged plan, not aggressive treatment first."],
          ["Maintenance", "Homecare and in-clinic plans work better when they are aligned."]
        ],
        prices: [
          ["Skin analysis", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Clarity and glow route", "from &pound;68", "Depth and intensity vary."],
          ["Texture and collagen route", "from &pound;100", "Protocol dependent."],
          ["Advanced resurfacing route", "from &pound;225", "Area and intensity dependent."]
        ],
        upsell: [
          ["Pigmentation and redness mapping", "Often appears alongside texture concerns."],
          ["Personalised active plan", "A daily plan can support clinic results."],
          ["Maintenance visits", "Useful between stronger treatments."]
        ]
      },
      acne: {
        label: "Acne, scarring and post-acne marks",
        intro: "We would usually separate active acne, scarring, post-inflammatory marks, redness, oiliness and barrier damage before planning treatment.",
        assess: ["Active acne", "Acne scarring", "Post-acne marks", "Oiliness", "Pores", "Barrier"],
        treatments: [
          ["Acne and scar assessment", "Separates active acne, marks and true scarring."],
          ["Acne-control route", "For active breakouts, oiliness, barrier and inflammation."],
          ["Texture and scar pathway", "For collagen remodelling once the skin is ready."],
          ["Advanced resurfacing pathway", "Only if suitability, downtime and skin tone support it."],
          ["Recovery and calming support", "Helps manage redness, inflammation and healing."]
        ],
        proofTitle: "Acne and scarring examples",
        reviews: [
          ["Realistic staging", "Acne and scarring usually need a sequence rather than one treatment."],
          ["Inflammation control", "Active acne needs calming before aggressive resurfacing."],
          ["Confidence", "Patients often value visible skin change with clear expectations."]
        ],
        prices: [
          ["Acne and skin assessment", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Calming support route", "from &pound;45", "Useful during active inflammation."],
          ["Texture route", "from &pound;100", "Protocol dependent."],
          ["Advanced scar route", "from &pound;225", "Area and intensity dependent."]
        ],
        upsell: [
          ["Post-acne pigmentation", "Often needs tone support alongside scar work."],
          ["At-home active plan", "Keeps active acne controlled between clinic visits."],
          ["Body acne route", "Can be reviewed if back or body skin is also relevant."]
        ]
      },
      pigment: {
        label: "Pigmentation, redness or uneven tone",
        intro: "We would usually identify whether the main issue is pigment, melasma, sun damage, redness, rosacea, veins, inflammation or post-acne marks.",
        assess: ["Pigmentation", "Melasma", "Redness", "Rosacea", "Visible vessels", "Sensitivity"],
        treatments: [
          ["Tone and redness assessment", "Distinguishes pigment-led concerns from vascular redness."],
          ["Tone-correction pathway", "For selected pigment, sun marks and uneven colour."],
          ["Redness-calming pathway", "For reactive skin, visible redness and inflammation."],
          ["Surface renewal pathway", "For uneven tone where the barrier can tolerate it."],
          ["Daily active plan", "For SPF, pigment control and redness maintenance."]
        ],
        proofTitle: "Pigmentation, redness and rosacea examples",
        reviews: [
          ["Correct diagnosis", "Pigment and redness need different treatment choices."],
          ["SPF and homecare", "Long-term control depends on routine as well as clinic support."],
          ["Sensitive skin", "Reactive skin benefits from a cautious staged approach."]
        ],
        prices: [
          ["Tone and redness assessment", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Tone-correction route", "from &pound;90", "Area and concern dependent."],
          ["Surface renewal route", "from &pound;68", "Depth and active choice vary."],
          ["Daily active plan", "from &pound;136/month", "Confirmed after analysis."]
        ],
        upsell: [
          ["Skin barrier work", "Redness often improves when barrier and inflammation are supported."],
          ["Texture support later", "May be considered once pigment or redness is controlled."],
          ["Hands, chest or neck", "Can be assessed alongside the face if relevant."]
        ]
      },
      definition: {
        label: "Face definition and profile balance",
        intro: "We would usually assess chin, jawline, cheek support, muscle pattern, submental fullness, skin laxity and facial proportions before suggesting treatment.",
        assess: ["Jawline", "Chin", "Cheeks", "Profile", "Muscle pattern", "Neck/submental area"],
        treatments: [
          ["Facial balance assessment", "Balances profile, safety, anatomy and proportions."],
          ["Structure and contour route", "For chin, cheek, profile or jawline support where suitable."],
          ["Muscle and slimming route", "For selected lower-face or jaw concerns."],
          ["Neck and submental route", "For local fullness or firmness where appropriate."],
          ["Tightening route", "For lower-face laxity and contour support."]
        ],
        proofTitle: "Jawline, chin and profile examples",
        reviews: [
          ["Facial balance", "Definition can come from structure, slimming, tightening or skin support."],
          ["Safety first", "Anatomy and suitability are assessed carefully before treatment."],
          ["Natural shape", "The goal is proportion and definition, not an overdone look."]
        ],
        prices: [
          ["Facial balance assessment", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Structure route", "from &pound;285", "Area and volume dependent."],
          ["Muscle route", "from &pound;176", "Dose and area dependent."],
          ["Neck or tightening route", "from &pound;140", "Area and course dependent."]
        ],
        upsell: [
          ["Skin tightening", "Jawline definition can improve with firming as well as structure."],
          ["Neck assessment", "The neck/submental area often affects the jawline result."],
          ["Skin quality", "Texture and glow can make definition look cleaner."]
        ]
      },
      body: {
        label: "Body shaping, fat reduction or tightening",
        intro: "We would usually map the exact body area, tissue thickness, skin laxity, cellulite, treatment tolerance and whether a course is realistic.",
        assess: ["Localised fat", "Skin laxity", "Cellulite", "Treatment area", "Course length", "Lifestyle"],
        treatments: [
          ["Body mapping assessment", "Checks area, tissue type, expectations and suitability."],
          ["Fat reduction route", "For selected stubborn pockets and contour planning."],
          ["Body contouring route", "For abdomen, flanks, thighs, arms or similar areas."],
          ["Skin tightening route", "For laxity, firmness and post-weight-change support."],
          ["Cellulite and body texture route", "For dimpling, uneven texture and body skin confidence."]
        ],
        proofTitle: "Body shaping and tightening examples",
        reviews: [
          ["Realistic courses", "Body treatments usually work as a plan, not a single promise."],
          ["Area selection", "The exact area and tissue type decide whether the route is suitable."],
          ["Combination thinking", "Fat reduction, contouring and tightening can be discussed together."]
        ],
        prices: [
          ["Body mapping assessment", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Single-area route", "from &pound;145", "Area and course dependent."],
          ["Larger-area route", "from &pound;195", "Confirmed after assessment."],
          ["Body skin route", "from &pound;225", "Scars, stretch marks or texture dependent."]
        ],
        upsell: [
          ["Skin tightening", "Often relevant after fat reduction or weight change."],
          ["Cellulite smoothing", "Can be discussed if texture is a concern."],
          ["Smooth skin planning", "Popular alongside body planning for convenience."]
        ]
      },
      hair: {
        label: "Hair thinning or scalp health",
        intro: "We would usually look at pattern, timeline, scalp health, shedding, medical history, current products and whether regenerative support is appropriate.",
        assess: ["Hair pattern", "Timeline", "Scalp health", "Shedding", "Density", "Medical triggers"],
        treatments: [
          ["Hair and scalp consultation", "Assesses pattern, triggers and suitability."],
          ["Regenerative scalp route", "For selected hair thinning and density concerns."],
          ["Scalp health route", "For cleansing, flaking, inflammation, oiliness or comfort."],
          ["Consistency and homecare plan", "Supports the route between visits."],
          ["Male or female pathway", "Pattern and medical context shape the recommendation."]
        ],
        proofTitle: "Hair and scalp examples",
        reviews: [
          ["Discreet planning", "Hair concerns often need privacy, consistency and realistic timelines."],
          ["Scalp plus hair", "Scalp health can affect how well a plan performs."],
          ["Pattern-led route", "Male and female patterns need different thinking."]
        ],
        prices: [
          ["Hair and scalp consultation", "Free consultation · &pound;50 reservation fee", "Starting point."],
          ["Regenerative scalp route", "from &pound;195", "Protocol dependent."],
          ["Advanced density route", "from &pound;290", "Confirmed after assessment."],
          ["Scalp health route", "from &pound;180", "Option dependent."]
        ],
        upsell: [
          ["Smooth skin planning", "Can be discussed for unwanted hair or grooming goals."],
          ["Scalp health support", "Useful when flaking, irritation or oiliness is part of the picture."],
          ["Skin or body confidence", "Can be discussed in the same visit if it matters to your goals."]
        ],
        male: true
      },
      unsure: {
        label: "A consultation-first starting point",
        intro: "If you are unsure, we keep the starting point broad: understand your priorities, check safety and show only the options that fit.",
        assess: ["Your main concern", "Medical suitability", "Skin quality", "Face/body/hair priority", "Budget", "Downtime"],
        treatments: [
          ["Doctor-led consultation", "The safest first step when you do not know what to book."],
          ["Skin, face, body or hair assessment", "We separate the concern before discussing a route."],
          ["Pathway shortlist", "You see the families that fit, not every possible option."],
          ["Staged plan", "We build a sequence rather than asking you to choose alone."]
        ],
        proofTitle: "Relevant examples after we know your concern",
        reviews: [
          ["No pressure", "Patients often start unsure and value being guided clearly."],
          ["Suitable options only", "The consultation narrows the possibilities to what makes sense."],
          ["Clear guidance", "Suitability and route options are discussed before treatment."]
        ],
        prices: [
          ["Doctor-led consultation", "Free consultation · &pound;50 reservation fee", "Best starting point."],
          ["Skin analysis", "Free to start", "For skin-led journeys."],
          ["Starting pathways", "from &pound;45", "Depends on selected route."],
          ["Combination plans", "confirmed after assessment", "Built around goals and suitability."]
        ],
        upsell: [
          ["Skin, face, body and hair review", "We can discuss more than one area if relevant."],
          ["Male pathway", "Available for hair, body, jawline, grooming and skin goals."],
          ["Maintenance", "Some goals are best solved with a simple ongoing plan."]
        ]
      }
    };

    function q(selector) {
      return root.querySelector(selector);
    }

    function qa(selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    function syncNoteChips() {
      var selected = Array.isArray(state.answers.note_prompts) ? state.answers.note_prompts : [];
      qa("[data-v4-note-chip]").forEach(function (chip) {
        var note = chip.getAttribute("data-v4-note-chip") || "";
        var active = !!(note && selected.indexOf(note) !== -1);
        chip.classList.toggle("is-active", active);
        chip.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function syncBothersFields(value) {
      state.answers.bothers = value || "";
      qa("[data-v3-answer='bothers']").forEach(function (field) {
        if (field.value !== state.answers.bothers) field.value = state.answers.bothers;
      });
    }

    function toggleNotePrompt(note) {
      if (!note) return;
      var selected = Array.isArray(state.answers.note_prompts) ? state.answers.note_prompts.slice() : [];
      var exists = selected.indexOf(note) !== -1;
      state.answers.note_prompts = exists ? selected.filter(function (item) { return item !== note; }) : selected.concat(note);
      syncNoteChips();
    }

    function patientNoteForBooking() {
      var parts = [];
      var selected = Array.isArray(state.answers.note_prompts) ? state.answers.note_prompts : [];
      var typed = String(state.answers.bothers || "").trim();
      if (selected.length) parts.push("Selected preferences: " + selected.join(", "));
      if (typed) parts.push("Patient note: " + typed);
      return parts.join("\n");
    }

    function escapeText(value) {
      var div = document.createElement("div");
      div.textContent = value == null ? "" : String(value);
      return div.innerHTML;
    }

    function escapeAttr(value) {
      return escapeText(value).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }

    function runReviewCallbacks() {
      var callbacks = reviewCallbacks.slice();
      reviewCallbacks = [];
      callbacks.forEach(function (callback) {
        try {
          callback();
        } catch (err) {}
      });
    }

    function runPabauReviewCallbacks() {
      var callbacks = pabauReviewCallbacks.slice();
      pabauReviewCallbacks = [];
      callbacks.forEach(function (callback) {
        try {
          callback();
        } catch (err) {}
      });
    }

    function trustModalCard(source, title, body, meta, featured) {
      return [
        '<article class="drsknn-v3-review-modal-card' + (featured ? " is-featured" : "") + '">',
        '<span class="drsknn-v3-review-source">' + escapeText(source) + '</span>',
        '<strong>' + escapeText(title) + '</strong>',
        body ? '<p>' + escapeText(body) + '</p>' : '',
        meta ? '<span>' + escapeText(meta) + '</span>' : '',
        '</article>'
      ].join("");
    }

    function isPatientThemeKey(key) {
      return String(key || "").indexOf("theme:") === 0;
    }

    function patientThemeKey(key) {
      return String(key || "").replace(/^theme:/, "");
    }

    function scoreReviewForTheme(text, keywords) {
      var haystack = String(text || "").toLowerCase();
      var score = 0;
      (keywords || []).forEach(function (keyword) {
        keyword = String(keyword || "").toLowerCase();
        if (!keyword || haystack.indexOf(keyword) === -1) return;
        score += keyword.length > 8 ? 3 : keyword.length > 5 ? 2 : 1;
      });
      return score;
    }

    function allSourceReviews() {
      var reviews = [];
      if (pabauReviewState.loaded && !pabauReviewState.failed) {
        reviews = reviews.concat(pabauReviewState.reviews || []);
      }
      if (reviewState.loaded && !reviewState.failed && reviewState.place && reviewState.place.reviews) {
        reviews = reviews.concat(reviewState.place.reviews.map(function (review) {
          return {
            source: "Google Reviews",
            sourceKind: "google",
            id: review.time || review.author_name || "",
            author_name: review.author_name || "Google reviewer",
            rating: review.rating || 5,
            text: review.text || "",
            relative_time_description: review.relative_time_description || "Google review",
            url: GOOGLE_REVIEWS_URL
          };
        }));
      }
      return reviews.filter(function (review) {
        return String(review.text || "").trim();
      });
    }

    function patientThemeSourceReviews(themeKey, limit) {
      var detail = patientThemeDetails[themeKey] || patientThemeDetails.clear;
      var keywords = detail.keywords || [];
      var scored = allSourceReviews().map(function (review) {
        return {
          review: review,
          score: scoreReviewForTheme(review.text, keywords)
        };
      }).filter(function (item) {
        return item.score > 0;
      });

      scored.sort(function (a, b) {
        if (a.score !== b.score) return b.score - a.score;
        if (a.review.sourceKind === b.review.sourceKind) return 0;
        return a.review.sourceKind === "pabau" ? -1 : 1;
      });

      return scored.slice(0, limit || 3).map(function (item) {
        return item.review;
      });
    }

    function sourceReviewUrl(review) {
      if (!review) return "";
      if (review.url) return review.url;
      if (review.sourceKind === "pabau" && review.id) return PABAU_REVIEWS_URL + "/" + encodeURIComponent(review.id);
      return review.sourceKind === "google" ? GOOGLE_REVIEWS_URL : PABAU_REVIEWS_URL;
    }

    function sourceReviewCard(review, featured) {
      var source = review.source || (review.sourceKind === "google" ? "Google Reviews" : "Pabau Reviews");
      var label = review.author_name || (review.sourceKind === "google" ? "Google reviewer" : "Verified patient");
      var date = review.relative_time_description || "";
      var service = review.service ? " · " + review.service : "";
      var url = sourceReviewUrl(review);
      return [
        '<article class="drsknn-v3-review-modal-card drsknn-v4-source-review-card' + (featured ? " is-featured" : "") + '">',
        '<span class="drsknn-v3-review-source">Actual ' + escapeText(source) + '</span>',
        '<strong>' + escapeText(label) + '</strong>',
        '<span class="drsknn-v4-source-review-meta"><span class="drsknn-v3-review-stars">' + stars(review.rating) + '</span><span>' + escapeText(date + service) + '</span></span>',
        '<p class="drsknn-v4-source-review-text">' + escapeText(review.text || "") + '</p>',
        url ? '<a class="drsknn-v4-source-review-link" href="' + escapeText(url) + '" target="_blank" rel="noopener">Open source review</a>' : '',
        '</article>'
      ].join("");
    }

    function patientThemeModalContent(themeKey) {
      var detail = patientThemeDetails[themeKey] || patientThemeDetails.clear;
      var loading = pabauReviewState.loading || reviewState.loading;
      var hasSettledSource = pabauReviewState.loaded || reviewState.loaded || pabauReviewState.failed || reviewState.failed;
      var matchedReviews = patientThemeSourceReviews(themeKey, 1);
      var cards = [];

      if (matchedReviews.length) {
        cards.push(sourceReviewCard(matchedReviews[0], true));
      } else if (loading || !hasSettledSource) {
        cards.push(trustModalCard("Loading source reviews", "Pulling real Google and Pabau reviews", "We are matching this theme to full review text returned by the source platforms.", "", true));
      } else {
        cards.push(trustModalCard("Source review check", "No live review text matched this theme", "This theme is hidden from the page when the live review feed does not support it. Open Google or Pabau below to inspect the source platforms directly.", "", true));
      }

      return [
        '<p class="drsknn-v3-review-modal-copy">This opens a real review returned by Google or Pabau for the selected theme.</p>',
        '<div class="drsknn-v3-review-modal-grid">',
        cards.join(""),
        '</div>',
        '<ul class="drsknn-v3-review-modal-list">',
        (detail.points || []).map(function (point) {
          return '<li>' + escapeText(point) + '</li>';
        }).join(""),
        '</ul>'
      ].join("");
    }

    function googleModalContent() {
      var place = reviewState.place || {};
      var rating = typeof place.rating === "number" ? place.rating.toFixed(1) : "5.0";
      var count = typeof place.user_ratings_total === "number" ? String(place.user_ratings_total) + "+" : "80+";
      var cards = [
        trustModalCard("Google Reviews", rating + " average rating", count + " Google Reviews for Dr Sknn Wilmslow. Real patients. Real results.", "", true)
      ];

      if (reviewState.loading) {
        cards.push(trustModalCard("Loading", "Loading live Google reviews", "We are pulling the latest available Google review text. This usually takes a moment.", "", false));
      } else if (reviewState.loaded && !reviewState.failed) {
        var reviews = matchingGoogleReviews();
        if (!reviews.length && place.reviews) reviews = place.reviews.slice();
        reviews.forEach(function (review) {
          var text = String(review.text || "").trim();
          if (!text) return;
          cards.push([
            '<article class="drsknn-v3-review-modal-card is-featured">',
            '<span class="drsknn-v3-review-source">' + (review._drsknnMatched ? "Matched Google Review" : "Live Google Review") + '</span>',
            '<strong>' + escapeText(review.author_name || "Google reviewer") + '</strong>',
            '<div class="drsknn-v3-review-stars">' + stars(review.rating) + '</div>',
            '<p>' + escapeText(text) + '</p>',
            '<span>' + escapeText(review.relative_time_description || "Google review") + '</span>',
            '</article>'
          ].join(""));
        });
      }

      if (cards.length === 1) {
        var fallbackTitle = reviewState.failed ? "Open the live Google profile" : "Google review snippets";
        var fallbackBody = reviewState.failed
          ? "The embedded Google feed did not return review snippets in this browser. The button below opens every live Google review directly on Google Maps."
          : "Google only returns a limited embeddable snippet set. Use the button below to read every live Google review on Maps.";
        cards.push(trustModalCard("Google Maps", fallbackTitle, fallbackBody, "", false));
      }

      return [
        '<p class="drsknn-v3-review-modal-copy">Google Reviews are shown as real patient feedback. We display embeddable review snippets when Google returns them, and link directly to the live Google profile for the full source.</p>',
        '<div class="drsknn-v3-review-modal-grid">',
        cards.join(""),
        '</div>',
        '<ul class="drsknn-v3-review-modal-list">',
        '<li>Personalised advice</li>',
        '<li>Caring team</li>',
        '<li>Clear explanations</li>',
        '<li>Natural results</li>',
        '</ul>'
      ].join("");
    }

    function pabauModalContent() {
      var cards = [
        trustModalCard("Pabau Reviews", pabauRatingText() + " verified patient feedback", pabauCountText() + ". Real patients. Real results.", "", true)
      ];

      if (pabauReviewState.loading) {
        cards.push(trustModalCard("Loading", "Loading live Pabau reviews", "We are pulling real published Pabau review text from the review source.", "", false));
      } else if (pabauReviewState.loaded && !pabauReviewState.failed) {
        pabauReviewState.reviews.slice(0, 3).forEach(function (review) {
          cards.push(sourceReviewCard(review, false));
        });
      } else if (pabauReviewState.failed) {
        cards.push(trustModalCard("Pabau Reviews", "Open the verified Pabau profile", "The embedded Pabau feed did not return review snippets in this browser. The button below opens the verified patient review page directly.", "", false));
      }

      return [
        '<p class="drsknn-v3-review-modal-copy">Pabau feedback is pulled from the public Pabau review source and shown as full review text where the source returns it.</p>',
        '<div class="drsknn-v3-review-modal-grid">',
        cards.join(""),
        '</div>',
        '<ul class="drsknn-v3-review-modal-list">',
        '<li>Personalised care</li>',
        '<li>Caring experience</li>',
        '<li>Patient-context trust</li>',
        '<li>Consultation-first approach</li>',
        '<li>Clear guidance first</li>',
        '</ul>'
      ].join("");
    }

    function doctorModalContent() {
      return [
        '<p class="drsknn-v3-review-modal-copy drsknn-v3-doctor-modal-bio">Dr Eddie Shaffu is a highly accomplished General Practitioner and aesthetics specialist, with advanced training in skin ageing and aesthetic medicine alongside his GP credentials. He has undertaken extensive global training across leading institutions in the UK, USA, Canada, Malta, Spain and Bahrain, with a strong focus on reconstructive and aesthetic plastic surgery as well as clinical research.</p>',
        '<div class="drsknn-v3-review-modal-grid">',
        '<article class="drsknn-v3-review-modal-card is-featured">',
        '<span class="drsknn-v3-review-source">Medical lead</span>',
        '<strong>Dr Eddie Shaffu</strong>',
        '<p>GP · Aesthetic medicine · Skin ageing &amp; regenerative treatments</p>',
        '<ul class="drsknn-v3-review-modal-credentials">',
        '<li>MB, BCh, BAO, LRCSl, LRCPl, NUI, MRCGP</li>',
        '<li>Associate Member &mdash; British College of Aesthetic Medicine</li>',
        '<li>MSc in Skin Ageing and Aesthetic Medicine</li>',
        '</ul>',
        '</article>',
        trustModalCard("Clinical approach", "Suitability checked first", "Your concern, goals, medical context and preferences shape what is recommended.", "", false),
        trustModalCard("Before booking", "Next step explained", "You see the safest route and booking options before committing to a plan.", "", false),
        trustModalCard("Guided journey", "No pressure", "You do not need to know which treatment to book before you start.", "", false),
        '</div>'
      ].join("");
    }

    function renderTrustModal(key) {
      var modal = q("[data-v3-review-modal]");
      if (!modal) return;
      var detail = trustDetails[key] || trustDetails.doctor;
      var themeKey = isPatientThemeKey(key) ? patientThemeKey(key) : "";
      if (themeKey) {
        var themeDetail = patientThemeDetails[themeKey] || patientThemeDetails.clear;
        detail = {
          title: themeDetail.label,
          subtitle: "Actual full review matched to this theme",
          icon: "✓"
        };
      }
      var icon = modal.querySelector("[data-v3-review-modal-icon]");
      var title = modal.querySelector("[data-v3-review-modal-title]");
      var subtitle = modal.querySelector("[data-v3-review-modal-subtitle]");
      var body = modal.querySelector("[data-v3-review-modal-body]");
      var foot = modal.querySelector("[data-v3-review-modal-foot]");
      modal.setAttribute("data-v4-modal-kind", themeKey ? "theme" : (key || "doctor"));
      if (key === "google" && reviewState.place) {
        var googleRating = typeof reviewState.place.rating === "number" ? reviewState.place.rating.toFixed(1) : "5.0";
        var googleCount = typeof reviewState.place.user_ratings_total === "number" ? String(reviewState.place.user_ratings_total) + "+" : "80+";
        detail = {
          title: googleRating + " Google Reviews",
          subtitle: googleCount + " live reviews · Real patients. Real results.",
          icon: "G"
        };
      }
      if (key === "pabau") {
        detail = {
          title: pabauRatingText() + " Pabau Reviews",
          subtitle: pabauCountText() + " · verified patient feedback",
          icon: "P"
        };
      }

      if (icon) {
        icon.innerHTML = detail.image
          ? '<img src="' + escapeText(detail.image) + '" alt="" loading="lazy" decoding="async">'
          : escapeText(detail.icon || "");
      }
      if (title) title.textContent = detail.title || "";
      if (subtitle) subtitle.textContent = detail.subtitle || "";
      if (body) {
        if (themeKey) body.innerHTML = patientThemeModalContent(themeKey);
        else if (key === "google") body.innerHTML = googleModalContent();
        else if (key === "pabau") body.innerHTML = pabauModalContent();
        else body.innerHTML = doctorModalContent();
      }
      if (foot) {
        if (themeKey) {
          foot.innerHTML = '<a href="' + GOOGLE_REVIEWS_URL + '" target="_blank" rel="noopener">Read Google Reviews</a><a href="' + PABAU_REVIEWS_URL + '" target="_blank" rel="noopener">Read Pabau Reviews</a><button type="button" data-v3-review-modal-close>Close</button>';
        } else if (key === "google") {
          foot.innerHTML = '<a href="' + GOOGLE_REVIEWS_URL + '" target="_blank" rel="noopener">Read every Google review</a><button type="button" data-v3-review-modal-close>Close</button>';
        } else if (key === "pabau") {
          foot.innerHTML = '<a href="' + PABAU_REVIEWS_URL + '" target="_blank" rel="noopener">Open Pabau Reviews</a><a href="/pages/dr-sknn-reviews">View reviews page</a><button type="button" data-v3-review-modal-close>Close</button>';
        } else {
          foot.innerHTML = '<a href="/pages/meet-the-team-dr-sknn-wilmslow-cheshire">Meet Dr Sknn</a><button type="button" data-v3-review-modal-close>Close</button>';
        }
      }
    }

    function openTrustModal(key, trigger) {
      var modal = q("[data-v3-review-modal]");
      var dialog = q("[data-v3-review-dialog]");
      if (!modal || !dialog) return;
      activeTrustModalKey = key || "doctor";
      lastTrustTrigger = trigger || document.activeElement;
      renderTrustModal(activeTrustModalKey);
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drsknn-v3-lock");
      if (activeTrustModalKey === "google" || isPatientThemeKey(activeTrustModalKey)) {
        ensureGoogleReviewSignals(function () {
          if (modal.classList.contains("is-open") && (activeTrustModalKey === "google" || isPatientThemeKey(activeTrustModalKey))) {
            renderTrustModal(activeTrustModalKey);
          }
        });
      }
      if (activeTrustModalKey === "pabau" || isPatientThemeKey(activeTrustModalKey)) {
        ensurePabauReviewSignals(function () {
          if (modal.classList.contains("is-open") && (activeTrustModalKey === "pabau" || isPatientThemeKey(activeTrustModalKey))) {
            renderTrustModal(activeTrustModalKey);
          }
        });
      }
      setTimeout(function () {
        if (dialog.focus) dialog.focus();
      }, 30);
    }

    function closeTrustModal() {
      var modal = q("[data-v3-review-modal]");
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      modal.removeAttribute("data-v4-modal-kind");
      activeTrustModalKey = "";
      if (!root.querySelector(".drsknn-v3-modal.is-open") && !root.querySelector(".drsknn-v3-proof-modal.is-open")) {
        document.body.classList.remove("drsknn-v3-lock");
      }
      if (lastTrustTrigger && lastTrustTrigger.focus) {
        setTimeout(function () { lastTrustTrigger.focus(); }, 30);
      }
    }

    function initFluxCanvas() {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      qa("[data-v3-flux-canvas]").forEach(function (canvas) {
        if (canvas.getAttribute("data-v3-flux-init") === "1") return;
        var ctx = canvas.getContext && canvas.getContext("2d");
        if (!ctx) return;

        canvas.setAttribute("data-v3-flux-init", "1");

        var width = 0;
        var height = 0;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var nodes = [
          { x: 0.28, y: 0.33, r: 7, color: "teal", phase: 0.2 },
          { x: 0.68, y: 0.25, r: 8, color: "gold", phase: 1.1 },
          { x: 0.78, y: 0.56, r: 7, color: "teal", phase: 2.0 },
          { x: 0.42, y: 0.66, r: 8, color: "gold", phase: 2.8 },
          { x: 0.56, y: 0.42, r: 10, color: "hub", phase: 0.7 }
        ];

        function resize() {
          var rect = canvas.getBoundingClientRect();
          width = Math.max(1, Math.round(rect.width));
          height = Math.max(1, Math.round(rect.height));
          dpr = Math.min(window.devicePixelRatio || 1, 2);
          canvas.width = Math.round(width * dpr);
          canvas.height = Math.round(height * dpr);
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }

        function nodePosition(node, time) {
          var drift = reduceMotion ? 0 : Math.sin(time * 0.001 + node.phase) * 7;
          var lift = reduceMotion ? 0 : Math.cos(time * 0.0008 + node.phase) * 5;
          return {
            x: node.x * width + drift,
            y: node.y * height + lift,
            r: node.r
          };
        }

        function strokeConnection(a, b, time, delay) {
          var gradient = ctx.createLinearGradient(a.x, a.y, b.x, b.y);
          gradient.addColorStop(0, "rgba(13,109,102,0.08)");
          gradient.addColorStop(0.48, "rgba(13,109,102,0.30)");
          gradient.addColorStop(1, "rgba(184,137,69,0.24)");
          ctx.strokeStyle = gradient;
          ctx.lineWidth = 1.4;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          var cx = (a.x + b.x) / 2 + (b.y - a.y) * 0.08;
          var cy = (a.y + b.y) / 2 - (b.x - a.x) * 0.05;
          ctx.quadraticCurveTo(cx, cy, b.x, b.y);
          ctx.stroke();

          var progress = reduceMotion ? 0.62 : ((time * 0.00022 + delay) % 1);
          var oneMinus = 1 - progress;
          var pulseX = oneMinus * oneMinus * a.x + 2 * oneMinus * progress * cx + progress * progress * b.x;
          var pulseY = oneMinus * oneMinus * a.y + 2 * oneMinus * progress * cy + progress * progress * b.y;
          ctx.fillStyle = "rgba(255,255,255,0.90)";
          ctx.strokeStyle = "rgba(13,109,102,0.45)";
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.arc(pulseX, pulseY, 4.2, 0, Math.PI * 2);
          ctx.fill();
          ctx.stroke();
        }

        function drawNode(point, node, time) {
          var isGold = node.color === "gold";
          var isHub = node.color === "hub";
          var pulse = reduceMotion ? 0 : Math.sin(time * 0.002 + node.phase) * 0.5 + 0.5;
          var glow = isHub ? 22 : 16;
          var fill = isGold ? "rgba(184,137,69,0.70)" : "rgba(13,109,102,0.70)";
          if (isHub) fill = "rgba(9,20,28,0.84)";

          var halo = ctx.createRadialGradient(point.x, point.y, 1, point.x, point.y, glow + pulse * 8);
          halo.addColorStop(0, isGold ? "rgba(184,137,69,0.28)" : "rgba(13,109,102,0.24)");
          halo.addColorStop(1, "rgba(255,255,255,0)");
          ctx.fillStyle = halo;
          ctx.beginPath();
          ctx.arc(point.x, point.y, glow + pulse * 8, 0, Math.PI * 2);
          ctx.fill();

          ctx.fillStyle = fill;
          ctx.strokeStyle = "rgba(255,255,255,0.86)";
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.arc(point.x, point.y, point.r + (isHub ? 3 : 0), 0, Math.PI * 2);
          ctx.fill();
          ctx.stroke();
        }

        function draw(time) {
          time = time || 0;
          ctx.clearRect(0, 0, width, height);

          var glow = ctx.createRadialGradient(width * 0.56, height * 0.40, 12, width * 0.56, height * 0.40, Math.max(width, height) * 0.62);
          glow.addColorStop(0, "rgba(13,109,102,0.12)");
          glow.addColorStop(0.46, "rgba(184,137,69,0.08)");
          glow.addColorStop(1, "rgba(255,255,255,0)");
          ctx.fillStyle = glow;
          ctx.fillRect(0, 0, width, height);

          ctx.strokeStyle = "rgba(13,109,102,0.10)";
          ctx.lineWidth = 1.1;
          for (var ring = 0; ring < 3; ring += 1) {
            ctx.beginPath();
            ctx.ellipse(width * 0.58, height * 0.42, width * (0.18 + ring * 0.09), height * (0.18 + ring * 0.07), -0.14, 0, Math.PI * 2);
            ctx.stroke();
          }

          var projectedNodes = nodes.map(function (node) {
            return nodePosition(node, time);
          });
          var hub = projectedNodes[4];
          projectedNodes.slice(0, 4).forEach(function (point, index) {
            strokeConnection(hub, point, time, index * 0.22);
          });
          strokeConnection(projectedNodes[0], projectedNodes[1], time, 0.36);
          strokeConnection(projectedNodes[2], projectedNodes[3], time, 0.62);

          projectedNodes.forEach(function (point, index) {
            drawNode(point, nodes[index], time);
          });

          if (!reduceMotion) window.requestAnimationFrame(draw);
        }

        resize();

        if (window.ResizeObserver) {
          var observer = new ResizeObserver(function () {
            resize();
            if (reduceMotion) draw(0);
          });
          observer.observe(canvas);
        } else {
          window.addEventListener("resize", resize);
        }

        draw(0);
      });
    }

    function closeTrustPanel(anchor) {
      var panel = anchor.querySelector("[data-v3-trust-panel]");
      if (!panel) return;
      panel.classList.remove("is-open");
      panel.setAttribute("hidden", "");
      panel.removeAttribute("data-v3-current");
      anchor.querySelectorAll("[data-v3-trust-toggle]").forEach(function (button) {
        button.classList.remove("is-active");
        button.setAttribute("aria-expanded", "false");
      });
    }

    function openTrustPanel(anchor, key) {
      var panel = anchor.querySelector("[data-v3-trust-panel]");
      var detail = trustDetails[key] || trustDetails.doctor;
      if (!panel) return;

      if (!panel.hasAttribute("hidden") && panel.getAttribute("data-v3-current") === key) {
        closeTrustPanel(anchor);
        return;
      }

      var media = panel.querySelector("[data-v3-trust-panel-media]");
      var title = panel.querySelector("[data-v3-trust-panel-title]");
      var subtitle = panel.querySelector("[data-v3-trust-panel-subtitle]");
      var body = panel.querySelector("[data-v3-trust-panel-body]");
      var list = panel.querySelector("[data-v3-trust-panel-list]");

      if (media) {
        media.innerHTML = detail.image
          ? '<img src="' + escapeText(detail.image) + '" alt="" loading="lazy" decoding="async">'
          : escapeText(detail.icon || "");
      }
      if (title) title.textContent = detail.title || "";
      if (subtitle) subtitle.textContent = detail.subtitle || "";
      if (body) body.textContent = detail.body || "";
      if (list) {
        list.innerHTML = (detail.points || []).map(function (point) {
          return "<li>" + escapeText(point) + "</li>";
        }).join("");
      }

      panel.removeAttribute("hidden");
      panel.classList.add("is-open");
      panel.setAttribute("data-v3-current", key);

      anchor.querySelectorAll("[data-v3-trust-toggle]").forEach(function (button) {
        var isActive = button.getAttribute("data-v3-trust-toggle") === key;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-expanded", isActive ? "true" : "false");
      });
    }

    function initTrustDocks() {
      qa("[data-v3-trust-anchor]").forEach(function (anchor) {
        if (anchor.getAttribute("data-v3-filled") === "1") return;
        anchor.innerHTML = trustDockHtml;
        anchor.setAttribute("data-v3-filled", "1");
        renderReviewSignals(path());
        anchor.querySelectorAll("[data-v3-trust-toggle]").forEach(function (button) {
          button.addEventListener("click", function () {
            openTrustModal(button.getAttribute("data-v3-trust-toggle") || "doctor", button);
          });
        });
        var close = anchor.querySelector("[data-v3-trust-close]");
        if (close) {
          close.addEventListener("click", function () {
            closeTrustPanel(anchor);
          });
        }
      });
    }

    qa("[data-v3-trust-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        openTrustModal(button.getAttribute("data-v3-trust-open") || "doctor", button);
      });
    });

    qa("[data-v4-patient-theme]").forEach(function (button) {
      button.addEventListener("click", function () {
        openTrustModal("theme:" + (button.getAttribute("data-v4-patient-theme") || "clear"), button);
      });
    });

    var patientThemeRotation = {
      timer: null,
      index: 0,
      paused: false
    };

    var mobilePatientThemeRotation = {
      timer: null,
      index: 0,
      paused: false
    };

    function desktopPatientThemePanel() {
      return q(".drsknn-v4-patient-pulse-desktop");
    }

    function mobilePatientThemePanel() {
      return q(".drsknn-v4-patient-pulse-mobile-inline");
    }

    function supportedDesktopPatientThemeButtons(panel) {
      if (!panel) return [];
      return Array.prototype.slice.call(panel.querySelectorAll("[data-v4-patient-theme]")).filter(function (button) {
        return !button.classList.contains("is-unsupported");
      });
    }

    function supportedMobilePatientThemeButtons(panel) {
      if (!panel) return [];
      return Array.prototype.slice.call(panel.querySelectorAll("[data-v4-patient-theme]")).filter(function (button) {
        return !button.classList.contains("is-unsupported");
      });
    }

    function setDesktopPatientThemeWindow(animate) {
      var panel = desktopPatientThemePanel();
      if (!panel) return;
      var buttons = supportedDesktopPatientThemeButtons(panel);
      var allButtons = Array.prototype.slice.call(panel.querySelectorAll("[data-v4-patient-theme]"));
      allButtons.forEach(function (button) {
        button.classList.remove("is-v4-theme-visible");
      });
      if (!buttons.length) return;

      panel.classList.add("is-v4-rotating");
      if (patientThemeRotation.index >= buttons.length) patientThemeRotation.index = 0;

      var visible = buttons.length <= 3
        ? buttons
        : [0, 1, 2].map(function (offset) {
            return buttons[(patientThemeRotation.index + offset) % buttons.length];
          });

      function applyVisible() {
        visible.forEach(function (button) {
          button.classList.add("is-v4-theme-visible");
        });
        panel.classList.remove("is-v4-theme-swapping");
      }

      if (animate) {
        panel.classList.add("is-v4-theme-swapping");
        window.setTimeout(applyVisible, 190);
      } else {
        applyVisible();
      }
    }

    function setMobilePatientThemeWindow(animate) {
      var panel = mobilePatientThemePanel();
      if (!panel) return;
      var buttons = supportedMobilePatientThemeButtons(panel);
      var allButtons = Array.prototype.slice.call(panel.querySelectorAll("[data-v4-patient-theme]"));
      allButtons.forEach(function (button) {
        button.classList.remove("is-v4-theme-visible");
      });
      if (!buttons.length) return;

      panel.classList.add("is-v4-rotating");
      if (mobilePatientThemeRotation.index >= buttons.length) mobilePatientThemeRotation.index = 0;

      var visibleCount = 2;
      var visible = buttons.length <= visibleCount
        ? buttons
        : [0, 1].map(function (offset) {
            return buttons[(mobilePatientThemeRotation.index + offset) % buttons.length];
          });

      function applyVisible() {
        visible.forEach(function (button) {
          button.classList.add("is-v4-theme-visible");
        });
        panel.classList.remove("is-v4-theme-swapping");
      }

      if (animate) {
        panel.classList.add("is-v4-theme-swapping");
        window.setTimeout(applyVisible, 170);
      } else {
        applyVisible();
      }
    }

    function rotateDesktopPatientThemes() {
      if (patientThemeRotation.paused) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var buttons = supportedDesktopPatientThemeButtons(desktopPatientThemePanel());
      if (buttons.length <= 3) return;
      patientThemeRotation.index = (patientThemeRotation.index + 3) % buttons.length;
      setDesktopPatientThemeWindow(true);
    }

    function rotateMobilePatientThemes() {
      if (mobilePatientThemeRotation.paused) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var buttons = supportedMobilePatientThemeButtons(mobilePatientThemePanel());
      if (buttons.length <= 2) return;
      mobilePatientThemeRotation.index = (mobilePatientThemeRotation.index + 2) % buttons.length;
      setMobilePatientThemeWindow(true);
    }

    function initPatientThemeRotation() {
      var panel = desktopPatientThemePanel();
      if (panel && panel.getAttribute("data-v4-theme-rotation-init") !== "1") {
        panel.setAttribute("data-v4-theme-rotation-init", "1");
        setDesktopPatientThemeWindow(false);
        panel.addEventListener("mouseenter", function () {
          patientThemeRotation.paused = true;
        });
        panel.addEventListener("mouseleave", function () {
          patientThemeRotation.paused = false;
        });
        panel.addEventListener("focusin", function () {
          patientThemeRotation.paused = true;
        });
        panel.addEventListener("focusout", function () {
          patientThemeRotation.paused = false;
        });
        patientThemeRotation.timer = window.setInterval(rotateDesktopPatientThemes, 4200);
      }

      var mobilePanel = mobilePatientThemePanel();
      if (mobilePanel && mobilePanel.getAttribute("data-v4-theme-rotation-init") !== "1") {
        mobilePanel.setAttribute("data-v4-theme-rotation-init", "1");
        setMobilePatientThemeWindow(false);
        mobilePanel.addEventListener("focusin", function () {
          mobilePatientThemeRotation.paused = true;
        });
        mobilePanel.addEventListener("focusout", function () {
          mobilePatientThemeRotation.paused = false;
        });
        mobilePanel.addEventListener("touchstart", function () {
          mobilePatientThemeRotation.paused = true;
          window.setTimeout(function () {
            mobilePatientThemeRotation.paused = false;
          }, 900);
        }, { passive: true });
        mobilePatientThemeRotation.timer = window.setInterval(rotateMobilePatientThemes, 3600);
      }
    }

    function uniqueValues(values) {
      var seen = {};
      return (values || []).filter(function (value) {
        value = String(value || "").trim();
        if (!value || seen[value]) return false;
        seen[value] = true;
        return true;
      });
    }

    function selectedGoals() {
      if (state.goals && state.goals.length) return state.goals.slice();
      return state.goal ? [state.goal] : [];
    }

    function setGoals(values) {
      var next = uniqueValues(values);
      if (next.length > 1 && next.indexOf("unsure") !== -1) {
        next = next.filter(function (value) { return value !== "unsure"; });
      }
      state.goals = next;
      state.goal = next[0] || "";
    }

    function toggleGoal(value) {
      var current = selectedGoals();
      if (value === "unsure") {
        setGoals(current.length === 1 && current[0] === "unsure" ? [] : ["unsure"]);
        return;
      }
      current = current.filter(function (item) { return item !== "unsure"; });
      if (current.indexOf(value) === -1) current.push(value);
      else current = current.filter(function (item) { return item !== value; });
      setGoals(current);
    }

    function selectedConcerns() {
      if (state.concerns && state.concerns.length) return state.concerns.slice();
      return state.concern ? [state.concern] : [];
    }

    function setConcerns(values) {
      var next = uniqueValues(values);
      if (next.length > 1 && next.indexOf("unsure") !== -1) {
        next = next.filter(function (value) { return value !== "unsure"; });
      }
      state.concerns = next;
      state.concern = next[0] || "";
    }

    function toggleConcern(value) {
      var current = selectedConcerns();
      if (value === "unsure") {
        setConcerns(current.length === 1 && current[0] === "unsure" ? [] : ["unsure"]);
        return;
      }
      current = current.filter(function (item) { return item !== "unsure"; });
      if (current.indexOf(value) === -1) current.push(value);
      else current = current.filter(function (item) { return item !== value; });
      setConcerns(current);
    }

    function selectedPriorities() {
      if (state.priorities && state.priorities.length) return state.priorities.slice();
      return state.priority ? [state.priority] : [];
    }

    function setPriorities(values) {
      var next = uniqueValues(values);
      state.priorities = next;
      state.priority = next[0] || "";
      if (next.indexOf("no-injectables") !== -1) state.answers.injectables = "no";
    }

    function togglePriority(value) {
      var current = selectedPriorities();
      if (current.indexOf(value) === -1) current.push(value);
      else current = current.filter(function (item) { return item !== value; });
      setPriorities(current);
    }

    function setMultiActive(selector, attr, values) {
      var map = {};
      uniqueValues(values).forEach(function (value) { map[value] = true; });
      qa(selector).forEach(function (button) {
        var active = !!map[button.getAttribute(attr)];
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function areaPathKeys() {
      var map = {
        skin: "skin",
        face: selectedConcerns().indexOf("definition") !== -1 ? "definition" : "tired",
        body: "body",
        hair: "hair",
        unsure: "unsure"
      };
      return selectedGoals().map(function (goal) {
        return map[goal] || "unsure";
      });
    }

    function relatedPathKeys() {
      return uniqueValues((selectedConcerns().length ? selectedConcerns() : ["unsure"]).concat(areaPathKeys()));
    }

    function pathDataForKey(key) {
      var base = paths[key] || paths.unsure;
      var copy = v4PathCopy[key] || v4PathCopy.unsure;
      var merged = Object.assign({}, base, copy);
      merged.proof = base.proof || copy.proof || commonProof;
      merged.proofTitle = copy.proofTitle || base.proofTitle || "Relevant before and after";
      return merged;
    }

    function mergeStringItems(primary, key) {
      var items = (primary[key] || []).slice();
      relatedPathKeys().forEach(function (pathKey) {
        var candidate = pathDataForKey(pathKey);
        if (candidate && candidate !== primary) items = items.concat(candidate[key] || []);
      });
      return uniqueValues(items);
    }

    function mergePairItems(primary, key, limit) {
      var seen = {};
      var items = [];
      function add(list) {
        (list || []).forEach(function (item) {
          var id = String((item && item[0]) || item || "").toLowerCase();
          if (!id || seen[id]) return;
          seen[id] = true;
          items.push(item);
        });
      }
      add(primary[key] || []);
      relatedPathKeys().forEach(function (pathKey) {
        var candidate = pathDataForKey(pathKey);
        if (candidate && candidate !== primary) add(candidate[key] || []);
      });
      return items.slice(0, limit || items.length);
    }

    function makeProofItem(src, title, badge, source) {
      return {
        src: src,
        title: title || "Relevant before and after",
        badge: badge || "Matched route",
        source: source || "matched"
      };
    }

    function addProofItem(items, seen, item) {
      if (!item || !item.src || seen[item.src]) return;
      seen[item.src] = true;
      items.push(item);
    }

    function bnaManifest() {
      return window.DR_SKNN_BNA_DATA || {};
    }

    function bnaImageSrc(item) {
      if (typeof item === "string") return item;
      if (!item) return "";
      return item.src || item.after || item.before || "";
    }

    function bnaImageTitle(item, data, category) {
      if (item && item.alt) return item.alt;
      if (item && item.caption) return item.caption;
      return (data && data.title) || bnaCategoryLabel(category);
    }

    function bnaCategoryProofItems(category) {
      var data = bnaManifest()[category || ""];
      if (!data || !Array.isArray(data.images)) return [];
      return data.images.map(function (item) {
        var src = bnaImageSrc(item);
        if (!src) return null;
        return makeProofItem(src, bnaImageTitle(item, data, category), data.title || bnaCategoryLabel(category), "bna");
      }).filter(Boolean);
    }

    function bnaStudioImageMarkup(item, data, index) {
      if (!item) return "";
      var title = bnaImageTitle(item, data, "");
      var caption = item.caption || title;
      if (item.before && item.after) {
        return [
          '<figure class="bna-tile bna-tile-comparison">',
          '<div class="bna-pair">',
          '<img loading="lazy" src="' + escapeAttr(item.before) + '" alt="' + escapeAttr(item.beforeAlt || title + " before") + '">',
          '<img loading="lazy" src="' + escapeAttr(item.after) + '" alt="' + escapeAttr(item.afterAlt || title + " after") + '">',
          '</div>',
          '<figcaption>' + escapeText(caption) + '</figcaption>',
          '</figure>'
        ].join("");
      }
      var src = bnaImageSrc(item);
      if (!src) return "";
      return [
        '<figure class="bna-tile">',
        '<img loading="lazy" src="' + escapeAttr(src) + '" alt="' + escapeAttr(title || "Before and after result " + (index + 1)) + '">',
        '<figcaption>' + escapeText(caption) + '</figcaption>',
        '</figure>'
      ].join("");
    }

    function buildBnaStudioSrcdoc(category, fullUrl) {
      var data = bnaManifest()[category || ""] || bnaManifest().transformations || {};
      var title = data.title || bnaCategoryLabel(category);
      var subtitle = data.subtitle || "Real clinic examples from the Dr Sknn before-and-after library.";
      var images = Array.isArray(data.images) ? data.images : [];
      var limitedImages = images.slice(0, 24);
      var imageHtml = limitedImages.length ? limitedImages.map(function (item, index) {
        return bnaStudioImageMarkup(item, data, index);
      }).join("") : '<div class="bna-empty">The matched proof library is loading. Open the full library if it does not appear.</div>';
      return [
        '<!doctype html>',
        '<html lang="en">',
        '<head>',
        '<meta charset="utf-8">',
        '<meta name="viewport" content="width=device-width,initial-scale=1">',
        '<base target="_blank">',
        '<style>',
        ':root{color-scheme:light;--ink:#07131b;--muted:#687985;--line:#d9e7e6;--teal:#08766d;--gold:#bd8a3a;--paper:#f8f5ed;}',
        '*{box-sizing:border-box}body{margin:0;background:linear-gradient(135deg,#fbfaf6,#eff8f6);color:var(--ink);font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
        '.wrap{min-height:100svh;padding:28px clamp(18px,4vw,48px) 40px;}',
        '.head{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:18px;align-items:end;margin:0 0 24px;}',
        '.kicker{display:block;color:var(--gold);font-size:12px;font-weight:900;letter-spacing:.18em;text-transform:uppercase;margin:0 0 8px;}',
        'h1{font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-size:clamp(34px,6vw,72px);line-height:.96;letter-spacing:0;margin:0 0 12px;}',
        'p{font-size:clamp(16px,2vw,20px);line-height:1.45;color:var(--muted);margin:0;max-width:760px;font-weight:680;}',
        '.open{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:12px 18px;border:1px solid var(--line);border-radius:10px;background:#fff;color:var(--ink);text-decoration:none;font-weight:900;white-space:nowrap;}',
        '.grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;}',
        '.bna-tile{overflow:hidden;margin:0;border:1px solid var(--line);border-radius:14px;background:#fff;box-shadow:0 20px 55px rgba(8,26,30,.08);}',
        '.bna-tile img{display:block;width:100%;aspect-ratio:1;object-fit:cover;background:#eee;}',
        '.bna-pair{display:grid;grid-template-columns:1fr 1fr;}',
        '.bna-pair img{aspect-ratio:3/4;}',
        'figcaption{padding:12px 14px 14px;color:#526470;font-size:13px;line-height:1.35;font-weight:760;}',
        '.bna-empty{padding:28px;border:1px solid var(--line);border-radius:14px;background:#fff;color:var(--muted);font-weight:800;}',
        '@media(max-width:900px){.head{grid-template-columns:1fr}.grid{grid-template-columns:repeat(2,minmax(0,1fr));}.open{justify-self:start}}',
        '@media(max-width:560px){.wrap{padding:18px 12px 28px}.grid{grid-template-columns:1fr;gap:12px}figcaption{font-size:12px}.open{width:100%}}',
        '</style>',
        '</head>',
        '<body>',
        '<main class="wrap">',
        '<header class="head"><div><span class="kicker">Matched before-and-after studio</span><h1>' + escapeText(title) + '</h1><p>' + escapeText(subtitle) + '</p></div><a class="open" href="' + escapeAttr(fullUrl) + '">Open full library</a></header>',
        '<section class="grid" aria-label="' + escapeAttr(title) + ' before and after examples">',
        imageHtml,
        '</section>',
        '</main>',
        '</body>',
        '</html>'
      ].join("");
    }

    function representativeProofItems(persona, category) {
      var pool = representativeProof[persona] || {};
      var categoryItems = pool[category] || [];
      var generalItems = pool.general || [];
      return categoryItems.concat(generalItems).map(function (item) {
        return makeProofItem(item[0], item[1], item[2], persona);
      });
    }

    function proofPersonaMode(primary) {
      var identity = state.answers.identity;
      if (identity === "male" || identity === "female") return identity;
      if (primary && primary.male === true) return "male";
      return "mixed";
    }

    function proofPreviewCopy(mode) {
      if (mode === "male") {
        return "Showing male examples first where they are relevant, with the full proof library still matched to your concern.";
      }
      if (mode === "female") {
        return "Showing female examples first where they are relevant, with the full proof library still matched to your concern.";
      }
      return "Showing a balanced preview where possible. Open the full library on the category closest to your concern.";
    }

    function proofItems(primary, category) {
      var matchedItems = [];
      var matchedSeen = {};
      var seen = {};
      function addMatched(pathData) {
        if (!pathData) return;
        (pathData.proof || commonProof).forEach(function (src) {
          addProofItem(matchedItems, matchedSeen, makeProofItem(src, pathData.proofTitle || "Relevant before and after", "Matched route", "matched"));
        });
      }
      addMatched(primary);
      relatedPathKeys().forEach(function (pathKey) {
        addMatched(pathDataForKey(pathKey));
      });

      var mode = proofPersonaMode(primary);
      var bnaItems = bnaCategoryProofItems(category);
      var femaleItems = representativeProofItems("female", category);
      var maleItems = representativeProofItems("male", category);
      var items = [];
      var limit = selectedGoals().length > 1 || selectedConcerns().length > 1 ? 10 : 6;
      function addSome(list, max) {
        var added = 0;
        (list || []).some(function (item) {
          var before = items.length;
          addProofItem(items, seen, item);
          if (items.length > before) added += 1;
          return added >= max || items.length >= limit;
        });
      }

      if (bnaItems.length) {
        addSome(bnaItems, limit);
        addSome(matchedItems, limit);
        if (items.length < 3) addSome(femaleItems.concat(maleItems), 3 - items.length);
      } else if (mode === "male") {
        addSome(maleItems, 2);
        addSome(matchedItems, 2);
        addSome(femaleItems, 1);
      } else if (mode === "female") {
        addSome(femaleItems, 2);
        addSome(matchedItems, 2);
        addSome(maleItems, 1);
      } else {
        addSome(matchedItems, 1);
        addSome(femaleItems, 1);
        addSome(maleItems, 1);
      }

      addSome(matchedItems, limit);
      addSome(femaleItems.concat(maleItems), limit);
      return items.slice(0, selectedGoals().length > 1 || selectedConcerns().length > 1 ? 10 : 6);
    }

    function matchedBnaCategory() {
      var concerns = selectedConcerns();
      var goals = selectedGoals();
      var priorities = selectedPriorities();
      var primary = concerns[0] || goals[0] || "unsure";

      if (concerns.indexOf("acne") !== -1) {
        return priorities.indexOf("stronger") !== -1 ? "acne-scarring" : "acne-treatment";
      }
      if (concerns.indexOf("pigment") !== -1) {
        return goals.indexOf("skin") !== -1 ? "pigmentation" : "redness";
      }
      if (concerns.indexOf("tired") !== -1) return "under-eye-treatment";
      if (concerns.indexOf("definition") !== -1) {
        if (priorities.indexOf("no-injectables") !== -1) return "hifu-facelift";
        return "jawline-fillers";
      }
      if (concerns.indexOf("ageing") !== -1) {
        if (priorities.indexOf("no-injectables") !== -1) return "skin-rejuvenation";
        if (goals.indexOf("face") !== -1 && priorities.indexOf("stronger") !== -1) return "neck-tightening";
        return "anti-wrinkle";
      }
      if (concerns.indexOf("body") !== -1 || goals.indexOf("body") !== -1) {
        if (priorities.indexOf("stronger") !== -1) return "fat-reduction";
        return "body-contouring";
      }
      if (concerns.indexOf("hair") !== -1 || goals.indexOf("hair") !== -1) return "hair-regrowth";
      return bnaCategoryByConcern[primary] || "transformations";
    }

    function bnaCategoryLabel(category) {
      return bnaCategoryLabels[category] || "Before and afters";
    }

    function bnaStudioUrl(category) {
      var key = category || "transformations";
      return BNA_STUDIO_URL + "?bna=" + encodeURIComponent(key) + "#drsknn-bna-studio";
    }

    function openBnaStudio(category) {
      var key = category || currentBnaCategory || matchedBnaCategory();
      var url = bnaStudioUrl(key);
      var modal = root.querySelector('[data-v3-modal="bna"]');
      if (modal) {
        var iframe = modal.querySelector("iframe");
        if (iframe) {
          iframe.setAttribute("data-src", url);
          iframe.removeAttribute("src");
          iframe.setAttribute("srcdoc", buildBnaStudioSrcdoc(key, url));
        }
        activateModal(modal);
      } else {
        window.location.href = url;
      }
    }

    function path() {
      return pathDataForKey(state.concern || selectedConcerns()[0] || "unsure");
    }

    function labelForGoal(value) {
      if (value === "skin") return labels.skin;
      if (value === "face") return labels.face;
      if (value === "body") return labels.body;
      if (value === "hair") return labels.hair;
      return labels[value] || value;
    }

    function labelForOutcome(value) {
      if (value === "skin") return labels.skinOutcome;
      if (value === "body") return labels.bodyOutcome;
      if (value === "hair") return labels.hairOutcome;
      return labels[value] || value;
    }

    function currentStepNumber() {
      if (state.screen === 2) return 1;
      if (state.screen === 3) return 2;
      if (state.screen === 4 || state.screen === 5) return 2;
      return 1;
    }

    function currentProgressLabel() {
      if (state.screen === 5) return "Your starting point";
      if (state.screen === 4) return "Optional note";
      return "Step " + currentStepNumber() + " of 2";
    }

    function currentProgressWidth() {
      return (state.screen === 5 || state.screen === 4) ? 100 : Math.round((currentStepNumber() / 2) * 100);
    }

    function setActive(selector, attr, value) {
      qa(selector).forEach(function (button) {
        var active = button.getAttribute(attr) === value;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function isStepValid(index) {
      if (index === 1) return selectedGoals().length > 0;
      if (index === 2) return selectedConcerns().length > 0;
      if (index === 3) return selectedPriorities().length > 0;
      return true;
    }

    function updateOutcomeVisibility() {
      var goals = selectedGoals();
      qa("[data-v3-outcome]").forEach(function (button) {
        var groups = (button.getAttribute("data-v3-groups") || "").split(/\s+/);
        var show = !goals.length || goals.some(function (goal) {
          return groups.indexOf(goal) !== -1;
        });
        button.classList.toggle("is-hidden", !show);
      });
    }

    function prioritySentence() {
      var map = {
        natural: "Because you want a natural result, the route should favour staged change and avoid over-treating.",
        downtime: "Because downtime matters, low-disruption options should be considered before stronger routes.",
        stronger: "Because you are open to stronger change, suitability and recovery time become especially important.",
        "no-injectables": "Because you prefer to avoid injectables, the first route should prioritise device, skincare and skin treatment options.",
        price: "Because clarity matters, the first recommendation should explain the route before you book.",
        guided: "Because you want guidance, the safest first step is a consultation-led route rather than choosing from a list alone."
      };
      return selectedPriorities().map(function (priority) {
        return map[priority] || "";
      }).filter(Boolean).join(" ");
    }

    function priorityShortSentence() {
      var selected = selectedPriorities();
      if (selected.length > 1) {
        return "We will balance " + selected.map(function (priority) {
          return (labels[priority] || priority).toLowerCase();
        }).join(", ").replace(/, ([^,]*)$/, " and $1") + ".";
      }
      var map = {
        natural: "We will keep the route staged and natural.",
        downtime: "Low-disruption options are prioritised first.",
        stronger: "Stronger options are only shown where suitability supports them.",
        "no-injectables": "Non-injectable options are prioritised first.",
        price: "The route is explained before booking.",
        guided: "The route stays consultation-led."
      };
      return selected.map(function (priority) {
        return map[priority] || "";
      }).filter(Boolean).slice(0, 3).join(" ");
    }

    function treatmentAllowed(item) {
      var name = item[0].toLowerCase();
      var injectables = state.answers.injectables;
      if (selectedPriorities().indexOf("no-injectables") !== -1) injectables = "no";
      if (injectables !== "no") return true;
      return !/(inject|filler|anti-wrinkle|polynucleotide|prp|exosome|booster|m-ha|nctf|tear trough)/.test(name);
    }

    function adjustedTreatments(source, limit) {
      var sourceList = Array.isArray(source) ? source : (source.treatments || []);
      var list = sourceList.filter(treatmentAllowed);
      if (!list.length) {
        list = [
          ["Doctor-led consultation", "We will focus on non-injectable options first."],
          ["Assessment route", "Useful for planning skin-led or device-led routes."],
          ["Non-injectable pathway", "Chosen after suitability and downtime are checked."]
        ];
      }
      return list.slice(0, limit || 6);
    }

    function adjustedPrices(source, limit) {
      var prices = (Array.isArray(source) ? source : (source.prices || [])).slice();
      if (state.answers.downtime === "little/no downtime" || selectedPriorities().indexOf("downtime") !== -1) {
        prices = prices.filter(function (item) {
          return !/(CO2|laser|resurfacing)/i.test(item[0]);
        });
      }
      return prices.slice(0, limit || 5);
    }

    function renderList(el, items, formatter) {
      if (!el) return;
      el.innerHTML = items.map(formatter).join("");
    }

    function stars(value) {
      var rating = Math.max(0, Math.min(5, Math.round(Number(value) || 5)));
      return "★★★★★".slice(0, rating) + "☆☆☆☆☆".slice(0, 5 - rating);
    }

    function excerpt(text, maxLength) {
      var value = String(text || "").replace(/\s+/g, " ").trim();
      if (value.length <= maxLength) return value;
      return value.slice(0, maxLength - 1).replace(/\s+\S*$/, "") + "…";
    }

    function matchingGoogleReviews(limit) {
      var place = reviewState.place;
      var reviews = place && place.reviews ? place.reviews.slice() : [];
      var keywords = uniqueValues(selectedConcerns().reduce(function (items, concern) {
        return items.concat(reviewKeywords[concern] || []);
      }, []).concat(
        areaPathKeys().reduce(function (items, key) {
          return items.concat(reviewKeywords[key] || []);
        }, [])
      ));
      var scored = reviews.map(function (review) {
        var haystack = String(review.text || "").toLowerCase();
        var matched = keywords.some(function (keyword) {
          return haystack.indexOf(keyword) !== -1;
        });
        return { review: review, matched: matched };
      });
      scored.sort(function (a, b) {
        if (a.matched === b.matched) return 0;
        return a.matched ? -1 : 1;
      });
      var result = scored.map(function (item) {
        item.review._drsknnMatched = item.matched;
        return item.review;
      });
      return typeof limit === "number" ? result.slice(0, limit) : result;
    }

    function pabauReviewsSnapshotQuery() {
      return [
        'fragment ReviewRelatedDetails on SocialSurveyFeedback {',
        'CompanyService { id ServiceCategory { id name } }',
        'Booking { id User { id image CmStaffGeneral { Fname Lname Avatar } } }',
        '}',
        'query ReviewsSnapshot($offset: Int!, $limit: Int!, $orderBy: [SocialSurveyFeedbackOrderByWithRelationInput], $where: SocialSurveyFeedbackWhereInput, $slug: String!) {',
        'findManySocialSurveyFeedback(skip: $offset, take: $limit, orderBy: $orderBy, where: {AND: [$where, {feedback_status: {equals: "published"}}]}) {',
        'id rating feedback_name feedback_comment date likes ...ReviewRelatedDetails',
        '}',
        'totalCount: findManySocialSurveyFeedbackCount(where: {AND: [$where, {feedback_status: {equals: "published"}}]})',
        'average: aggregateSocialSurveyFeedback(where: {AND: [{Company: {slug: {equals: $slug}}}, {feedback_status: {equals: "published"}}]}) { _avg { rating } }',
        '}'
      ].join(' ');
    }

    function formatPabauDate(timestamp) {
      var value = Number(timestamp);
      if (!value) return "Pabau review";
      try {
        return new Date(value * 1000).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
      } catch (err) {
        return "Pabau review";
      }
    }

    function normalisePabauReview(review) {
      var category = review && review.CompanyService && review.CompanyService.ServiceCategory;
      return {
        source: "Pabau Reviews",
        sourceKind: "pabau",
        id: review && review.id ? String(review.id) : "",
        author_name: (review && review.feedback_name ? String(review.feedback_name).trim() : "") || "Verified patient",
        rating: review && review.rating ? Number(review.rating) : 5,
        text: review && review.feedback_comment ? String(review.feedback_comment).trim() : "",
        relative_time_description: formatPabauDate(review && review.date),
        service: category && category.name ? String(category.name) : "",
        url: review && review.id ? PABAU_REVIEWS_URL + "/" + encodeURIComponent(review.id) : PABAU_REVIEWS_URL
      };
    }

    function pabauRatingText() {
      var value = Number(pabauReviewState.averageRating || 4.99);
      return (Math.round(value * 100) / 100).toFixed(2) + "/5";
    }

    function pabauCountText() {
      var count = Number(pabauReviewState.totalCount || 183);
      return String(count) + " verified reviews";
    }

    function renderPabauSignals() {
      qa("[data-v3-pabau-rating]").forEach(function (el) {
        el.textContent = pabauRatingText();
      });
      qa("[data-v3-pabau-count]").forEach(function (el) {
        el.textContent = pabauCountText();
      });
    }

    function renderPatientThemeSupport() {
      var sourcesSettled = (pabauReviewState.loaded || pabauReviewState.failed) && (reviewState.loaded || reviewState.failed);
      qa("[data-v4-patient-theme]").forEach(function (button) {
        var key = button.getAttribute("data-v4-patient-theme") || "clear";
        var matches = patientThemeSourceReviews(key, 1);
        var unsupported = sourcesSettled && !matches.length;
        button.classList.toggle("is-unsupported", unsupported);
        button.disabled = unsupported;
        if (matches.length) {
          button.setAttribute("title", "Read an actual " + (matches[0].source || "source") + " review");
        } else {
          button.setAttribute("title", sourcesSettled ? "No live source review text matched this theme" : "Loading source reviews");
        }
      });
      setDesktopPatientThemeWindow(false);
      setMobilePatientThemeWindow(false);
    }

    function renderReviewSignals(selectedPath) {
      var container = q("[data-v3-live-review-signals]");
      var note = q("[data-v3-review-note]");
      var place = reviewState.place || {};
      var rating = typeof place.rating === "number" ? place.rating.toFixed(1) : "5.0";
      var count = typeof place.user_ratings_total === "number" ? String(place.user_ratings_total) + "+" : "80+";
      renderPabauSignals();
      renderPatientThemeSupport();
      qa("[data-v3-google-rating]").forEach(function (el) {
        el.textContent = rating;
      });
      qa("[data-v3-google-count]").forEach(function (el) {
        el.textContent = count + " live reviews";
      });
      if (!container) return;

      var cards = [
        '<article class="drsknn-v3-review-card"><span class="drsknn-v3-review-source">Live Google Reviews</span><strong>' + rating + ' average rating</strong><div class="drsknn-v3-review-stars">★★★★★</div><p>' + count + ' Google Reviews for Dr Sknn Wilmslow. Real patients. Real results.</p></article>',
        '<article class="drsknn-v3-review-card"><span class="drsknn-v3-review-source">Pabau Reviews</span><strong>' + pabauRatingText() + ' verified patient feedback</strong><div class="drsknn-v3-review-stars">★★★★★</div><p>' + pabauCountText() + '. Real patients. Real results.</p></article>'
      ];

      if (reviewState.loaded && !reviewState.failed) {
        matchingGoogleReviews().forEach(function (review) {
          var text = excerpt(review.text || "", 170);
          if (!text) return;
          cards.push(
            '<article class="drsknn-v3-review-card is-live' + (review._drsknnMatched ? " is-matched" : "") + '"><span class="drsknn-v3-review-source">' + (review._drsknnMatched ? "Matched Google Review" : "Live Google Review") + '</span><strong>' +
            escapeText(review.author_name || "Google reviewer") +
            '</strong><div class="drsknn-v3-review-stars">' + stars(review.rating) + '</div><p>' +
            escapeText(text) +
            '</p><span>' + escapeText(review.relative_time_description || "Google review") + '</span></article>'
          );
        });
      }

      if (cards.length <= 2) {
        mergePairItems(selectedPath, "reviews", selectedGoals().length > 1 ? 4 : 2).forEach(function (item) {
          cards.push(
            '<article class="drsknn-v3-review-card"><span class="drsknn-v3-review-source">Similar patient theme</span><strong>' +
            escapeText(item[0]) +
            '</strong><p>' + escapeText(item[1]) + '</p></article>'
          );
        });
      }

      container.innerHTML = cards.join("");

      if (note) {
        if (reviewState.loading) {
          note.textContent = "Loading Google Reviews. Pabau Reviews remain shown as verified patient feedback.";
        } else if (reviewState.loaded && !reviewState.failed) {
          note.textContent = "Showing every live Google review snippet Google returns for Dr Sknn, with the most relevant reviews placed first. Pabau Reviews remain shown as verified patient feedback.";
        } else {
          note.textContent = "Google rating is linked to the live Maps profile. Pabau Reviews remain shown as verified patient feedback.";
        }
      }
    }

    function loadGooglePlacesScript(callback) {
      if (!GOOGLE_PLACES_API_KEY || !GOOGLE_PLACE_ID) return;
      if (window.google && window.google.maps && window.google.maps.places) {
        callback();
        return;
      }
      var existing = document.getElementById("drsknn-v3-google-places-js");
      if (existing) {
        existing.addEventListener("load", callback);
        return;
      }
      var script = document.createElement("script");
      script.id = "drsknn-v3-google-places-js";
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE_PLACES_API_KEY) + "&libraries=places&v=weekly";
      script.async = true;
      script.defer = true;
      script.onload = callback;
      script.onerror = function () {
        reviewState.loading = false;
        reviewState.failed = true;
        renderReviewSignals(path());
        runReviewCallbacks();
      };
      document.head.appendChild(script);
    }

    function ensureGoogleReviewSignals(callback) {
      if (typeof callback === "function") reviewCallbacks.push(callback);
      if (reviewState.loaded || reviewState.failed) {
        runReviewCallbacks();
        return;
      }
      if (reviewState.loading) return;
      reviewState.loading = true;
      renderReviewSignals(path());
      loadGooglePlacesScript(function () {
        try {
          var service = new google.maps.places.PlacesService(document.createElement("div"));
          service.getDetails(
            {
              placeId: GOOGLE_PLACE_ID,
              fields: ["name", "rating", "user_ratings_total", "reviews"]
            },
            function (placeData, status) {
              reviewState.loading = false;
              if (status === google.maps.places.PlacesServiceStatus.OK && placeData) {
                reviewState.loaded = true;
                reviewState.place = placeData;
              } else {
                reviewState.failed = true;
              }
              renderReviewSignals(path());
              runReviewCallbacks();
            }
          );
        } catch (err) {
          reviewState.loading = false;
          reviewState.failed = true;
          renderReviewSignals(path());
          runReviewCallbacks();
        }
      });
    }

    function ensurePabauReviewSignals(callback) {
      if (typeof callback === "function") pabauReviewCallbacks.push(callback);
      if (pabauReviewState.loaded || pabauReviewState.failed) {
        runPabauReviewCallbacks();
        return;
      }
      if (pabauReviewState.loading) return;
      pabauReviewState.loading = true;
      renderPabauSignals();
      renderPatientThemeSupport();

      var variables = {
        offset: 0,
        limit: 200,
        orderBy: [{ date: "desc" }],
        where: { Company: { slug: { equals: PABAU_REVIEW_SLUG } } },
        slug: PABAU_REVIEW_SLUG
      };

      fetch(PABAU_GRAPHQL_URL, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: {
          "content-type": "application/json",
          "x-app": "pabau",
          "x-token-version": "1",
          "x-company-slug": PABAU_REVIEW_SLUG
        },
        body: JSON.stringify({
          operationName: "ReviewsSnapshot",
          variables: variables,
          query: pabauReviewsSnapshotQuery()
        })
      }).then(function (response) {
        if (!response.ok) throw new Error("Pabau review request failed");
        return response.json();
      }).then(function (payload) {
        var data = payload && payload.data ? payload.data : {};
        var reviews = data.findManySocialSurveyFeedback || [];
        pabauReviewState.loading = false;
        pabauReviewState.loaded = true;
        pabauReviewState.failed = false;
        pabauReviewState.totalCount = Number(data.totalCount || pabauReviewState.totalCount || 183);
        pabauReviewState.averageRating = Number(data.average && data.average._avg && data.average._avg.rating ? data.average._avg.rating : pabauReviewState.averageRating || 4.99);
        pabauReviewState.reviews = reviews.map(normalisePabauReview).filter(function (review) {
          return String(review.text || "").trim();
        });
        renderPabauSignals();
        renderReviewSignals(path());
        runPabauReviewCallbacks();
      }).catch(function () {
        pabauReviewState.loading = false;
        pabauReviewState.failed = true;
        renderPabauSignals();
        renderPatientThemeSupport();
        runPabauReviewCallbacks();
      });
    }

    function renderResult() {
      var selectedPath = path();
      var customConcern = (state.answers.bothers || "").trim();
      var identity = state.answers.identity;
      var goals = selectedGoals();
      var concerns = selectedConcerns();
      var priorities = selectedPriorities();
      var showMale = identity === "male" || selectedPath.male === true || goals.indexOf("hair") !== -1 || goals.indexOf("body") !== -1 || concerns.indexOf("definition") !== -1 || concerns.indexOf("body") !== -1 || concerns.indexOf("hair") !== -1;

      var resultTitle = q("[data-v3-result-title]");
      var resultIntro = q("[data-v3-result-intro]");
      var summary = q("[data-v3-summary]");
      var assessments = q("[data-v3-assessments]");
      var treatments = q("[data-v3-treatments]");
      var reviewThemes = q("[data-v3-review-themes]");
      var proof = q("[data-v3-proof]");
      var proofTitle = q("[data-v3-proof-title]");
      var proofNote = q("[data-v3-proof-note]");
      var proofLibraryLink = q(".drsknn-v4-proof-library");
      var upsells = q("[data-v3-upsells]");
      var upsellTitle = q("[data-v3-upsell-title]");
      var upsellNote = q("[data-v3-upsell-note]");

      if (resultTitle) {
        resultTitle.textContent = concerns.length > 1
          ? "Your combined starting point"
          : selectedPath.label;
      }
      if (resultIntro) {
        var intro = goals.length > 1 || concerns.length > 1
          ? "We will separate your concerns in clinic and choose the safest first route."
          : "Start here, then confirm suitability and the safest route with the clinic.";
        if (goals.length > 1 || concerns.length > 1) {
          intro += " One clear next step, not a long treatment menu.";
        }
        if (priorityShortSentence()) intro += " " + priorityShortSentence();
        resultIntro.textContent = intro;
      }

      if (summary) {
        var chips = goals.length ? goals.map(labelForGoal) : [];
        chips = chips.concat((concerns.length ? concerns : ["unsure"]).map(labelForOutcome));
        chips = chips.concat((priorities.length ? priorities : ["guided"]).map(function (priority) {
          return labels[priority] || "Guided by Dr Sknn";
        }));
        if (customConcern) chips.push("Focus: " + excerpt(customConcern, 54));
        if (identity !== "not shared") chips.push(identity === "male" ? "Male pathway" : "Female pathway");
        summary.innerHTML = chips.map(function (item) {
          return '<span class="drsknn-v3-summary-chip">' + escapeText(item) + "</span>";
        }).join("");
      }

      if (assessments) {
        assessments.innerHTML = mergeStringItems(selectedPath, "assess").slice(0, 6).map(function (item) {
          return '<span class="drsknn-v3-tag">' + escapeText(item) + "</span>";
        }).join("");
      }

      renderList(treatments, adjustedTreatments(mergePairItems(selectedPath, "treatments", goals.length > 1 ? 6 : 4), goals.length > 1 ? 4 : 3), function (item) {
        return "<li><strong>" + escapeText(item[0]) + "</strong><span>" + escapeText(item[1]) + "</span></li>";
      });

      renderList(reviewThemes, mergePairItems(selectedPath, "reviews", goals.length > 1 ? 4 : 3), function (item) {
        return "<li><strong>" + escapeText(item[0]) + "</strong><span>" + escapeText(item[1]) + "</span></li>";
      });

      renderReviewSignals(selectedPath);
      ensureGoogleReviewSignals();

      if (proof) {
        currentBnaCategory = matchedBnaCategory();
        var bnaLabel = bnaCategoryLabel(currentBnaCategory);
        var proofMode = proofPersonaMode(selectedPath);
        currentProofItems = proofItems(selectedPath, currentBnaCategory);
        var bnaUrl = bnaStudioUrl(currentBnaCategory);
        if (proofTitle) {
          proofTitle.textContent = "Matched real results";
        }
        if (proofNote) {
          proofNote.textContent = proofPreviewCopy(proofMode);
        }
        if (proofLibraryLink) {
          proofLibraryLink.href = bnaUrl;
          proofLibraryLink.textContent = "Open matched library";
          proofLibraryLink.setAttribute("data-v4-bna-open", "");
          proofLibraryLink.setAttribute("data-v4-bna-category", currentBnaCategory);
        }
        var previewCards = currentProofItems.slice(0, 3).map(function (item, index) {
          var title = item.title || "Relevant before and after";
          return '<figure class="drsknn-v3-proof-card"><button class="drsknn-v3-proof-open" type="button" data-v3-proof-index="' + index + '" aria-label="Open before and after image ' + (index + 1) + ' full screen"><img loading="lazy" src="' + item.src + '" alt="' + escapeText(title) + '"></button><figcaption><strong>' + escapeText(title) + " " + (index + 1) + '</strong><span>Matched to your selected concern. Individual results vary.</span></figcaption></figure>';
        }).join("");
        proof.innerHTML = [
          '<article class="drsknn-v4-proof-studio-card">',
          '<div class="drsknn-v4-proof-studio-copy">',
          '<small>Matched proof studio</small>',
          '<strong>' + escapeText(bnaLabel) + '</strong>',
          '<p>' + escapeText(proofPreviewCopy(proofMode)) + '</p>',
          '<div class="drsknn-v4-proof-studio-actions">',
          '<button class="drsknn-v3-btn drsknn-v3-btn-dark" type="button" data-v4-bna-open data-v4-bna-category="' + escapeText(currentBnaCategory) + '">Open matched results</button>',
          '<button class="drsknn-v3-btn drsknn-v3-btn-light" type="button" data-v4-bna-open data-v4-bna-category="transformations">View transformations</button>',
          '</div>',
          '</div>',
          '<div class="drsknn-v4-proof-studio-preview" aria-label="A few relevant proof previews">',
          previewCards,
          '</div>',
          '</article>'
        ].join("");
      }

      var upsellItems = mergePairItems(selectedPath, "upsell", goals.length > 1 ? 8 : 5);
      if (concerns.indexOf("tired") !== -1) {
        upsellItems.unshift(["Common supporting options", "Skin quality, under-eye, expression, structure and recovery support can be assessed together."]);
      }
      if (concerns.indexOf("acne") !== -1) {
        upsellItems.unshift(["Often paired with acne and scar plans", "Inflammation control, texture work, pigment marks, recovery and homecare can be staged together."]);
      }
      if (showMale) {
        upsellItems.unshift(["Also commonly discussed by male patients", "Hair, scalp, jawline, body contour, grooming and skin confidence can be reviewed if relevant."]);
      }

      if (upsellTitle) {
        upsellTitle.textContent = showMale ? "Also commonly discussed by male patients" : "Also commonly discussed for this goal";
      }

      renderList(upsells, upsellItems.slice(0, 5), function (item) {
        return "<li><strong>" + escapeText(item[0]) + "</strong><span>" + escapeText(item[1]) + "</span></li>";
      });

      if (upsellNote) {
        upsellNote.textContent = "These can be discussed during your visit if relevant to your goals.";
      }
    }

    function renderProofModal() {
      var modal = q("[data-v3-proof-modal]");
      if (!modal || !currentProofItems.length) return;
      currentProofIndex = Math.max(0, Math.min(currentProofIndex, currentProofItems.length - 1));
      var item = currentProofItems[currentProofIndex] || {};
      var image = modal.querySelector("[data-v3-proof-modal-image]");
      var title = modal.querySelector("[data-v3-proof-modal-title]");
      var subtitle = modal.querySelector("[data-v3-proof-modal-subtitle]");
      var count = modal.querySelector("[data-v3-proof-modal-count]");
      if (image) {
        image.src = item.src || "";
        image.alt = item.title || "Dr Sknn before and after";
      }
      if (title) title.textContent = item.title || "Before-and-after";
      if (subtitle) subtitle.textContent = "Matched to your selected concerns";
      if (count) count.textContent = (currentProofIndex + 1) + " of " + currentProofItems.length;
    }

    function relabelGlobalV4Ctas() {
      Array.prototype.slice.call(document.querySelectorAll("a, button")).forEach(function (el) {
        var label = String(el.textContent || "").replace(/\s+/g, " ").trim();
        if (label === "Book Treatment") {
          el.textContent = "Discuss Route";
        }
      });
    }

    function initV4HeroProofReel() {
      var reel = q("[data-v4-hero-proof-reel]");
      if (!reel || heroProofFrames.length < 3) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      heroProofFrames.forEach(function (frame) {
        var image = new Image();
        image.src = frame.src;
      });
      var images = Array.prototype.slice.call(reel.querySelectorAll("[data-v4-hero-proof-image]"));
      var label = q("[data-v4-hero-proof-label]");
      if (images.length < 2) return;
      var index = 0;
      var active = images[0];
      var waiting = images[1];

      function commitFrame(frame) {
        if (!frame || !frame.src || !active || !waiting) return;
        if (waiting.getAttribute("src") !== frame.src) waiting.setAttribute("src", frame.src);
        var ready = waiting.decode ? waiting.decode().catch(function () {}) : Promise.resolve();
        ready.then(function () {
          window.requestAnimationFrame(function () {
            if (label) {
              label.classList.add("is-changing");
              window.setTimeout(function () {
                label.textContent = frame.label || "Transformation";
                label.classList.remove("is-changing");
              }, 260);
            }
            waiting.classList.add("is-active");
            active.classList.remove("is-active");
            var previous = active;
            active = waiting;
            waiting = previous;
          });
        });
      }

      window.setInterval(function () {
        index = (index + 1) % heroProofFrames.length;
        commitFrame(heroProofFrames[index]);
      }, 2000);
    }

    function openProofModal(index, trigger) {
      var modal = q("[data-v3-proof-modal]");
      var dialog = q("[data-v3-proof-dialog]");
      if (!modal || !dialog || !currentProofItems.length) return;
      currentProofIndex = Number(index) || 0;
      lastTrustTrigger = trigger || document.activeElement;
      renderProofModal();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drsknn-v3-lock");
      setTimeout(function () {
        if (dialog.focus) dialog.focus();
      }, 30);
    }

    function closeProofModal() {
      var modal = q("[data-v3-proof-modal]");
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      if (!root.querySelector(".drsknn-v3-modal.is-open") && !root.querySelector(".drsknn-v3-review-modal.is-open") && !root.querySelector(".drsknn-v3-proof-modal.is-open")) {
        document.body.classList.remove("drsknn-v3-lock");
      }
      if (lastTrustTrigger && lastTrustTrigger.focus) {
        setTimeout(function () { lastTrustTrigger.focus(); }, 30);
      }
    }

    function moveProofModal(direction) {
      if (!currentProofItems.length) return;
      currentProofIndex = (currentProofIndex + direction + currentProofItems.length) % currentProofItems.length;
      renderProofModal();
    }

    function parseServiceValues(value) {
      return String(value || "")
        .split(/\s+/)
        .map(function (item) { return item.trim(); })
        .filter(Boolean);
    }

    function startServiceRoute(card) {
      var goals = parseServiceValues(card.getAttribute("data-v3-service-goals"));
      var concerns = parseServiceValues(card.getAttribute("data-v3-service-outcomes"));
      var identity = card.getAttribute("data-v3-service-identity") || "not shared";
      if (goals.length) setGoals(goals);
      if (concerns.length) setConcerns(concerns);
      state.answers.identity = identity;
      updateOutcomeVisibility();
      setMultiActive("[data-v3-goal]", "data-v3-goal", selectedGoals());
      setMultiActive("[data-v3-outcome]", "data-v3-outcome", selectedConcerns());
      showScreen(concerns.length ? 3 : 2);
    }

    function showScreen(index) {
      state.screen = Math.max(0, Math.min(screens.length - 1, index));
      qa("[data-v3-screen]").forEach(function (screen) {
        screen.classList.toggle("is-active", screen.getAttribute("data-v3-screen") === screens[state.screen]);
      });

      qa("[data-v3-progress-label]").forEach(function (el) {
        el.textContent = currentProgressLabel();
      });
      qa("[data-v3-progress-fill]").forEach(function (el) {
        el.style.width = String(currentProgressWidth()) + "%";
      });

      qa("[data-v3-next]").forEach(function (button) {
        button.disabled = !isStepValid(state.screen);
      });

      updateOutcomeVisibility();
      setMultiActive("[data-v3-goal]", "data-v3-goal", selectedGoals());
      setMultiActive("[data-v3-outcome]", "data-v3-outcome", selectedConcerns());
      setMultiActive("[data-v3-priority]", "data-v3-priority", selectedPriorities());
      if (state.screen === 5) renderResult();

      var active = root.querySelector('[data-v3-screen="' + screens[state.screen] + '"]');
      if (active && active.scrollIntoView) active.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    qa("[data-v3-start]").forEach(function (button) {
      button.addEventListener("click", function () {
        showScreen(2);
      });
    });

    qa("[data-v3-service-card]").forEach(function (card) {
      card.addEventListener("click", function () {
        startServiceRoute(card);
      });
    });

    qa("[data-v3-service-nav]").forEach(function (button) {
      button.addEventListener("click", function () {
        var carousel = q("[data-v3-service-carousel]");
        if (!carousel || !carousel.scrollBy) return;
        var direction = Number(button.getAttribute("data-v3-service-nav") || "1");
        carousel.scrollBy({
          left: direction * Math.max(170, carousel.clientWidth * 0.76),
          behavior: "smooth"
        });
      });
    });

    qa("[data-v3-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (!isStepValid(state.screen)) return;
        if (state.screen === 3) {
          showScreen(5);
          return;
        }
        showScreen(state.screen + 1);
      });
    });

    qa("[data-v3-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (state.screen === 5) {
          showScreen(3);
          return;
        }
        showScreen(state.screen === 2 ? 0 : state.screen - 1);
      });
    });

    qa("[data-v3-reset]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.goals = [];
        state.goal = "";
        state.concerns = [];
        state.concern = "";
        state.priorities = [];
        state.priority = "";
        state.answers = {
          bothers: "",
          note_prompts: [],
          downtime: "little/no downtime",
          injectables: "not sure",
          identity: "not shared"
        };
        syncBothersFields("");
        syncNoteChips();
        qa("[data-v3-answer-choice]").forEach(function (btn) {
          var key = btn.getAttribute("data-v3-answer-choice");
          var value = btn.getAttribute("data-v3-value");
          btn.classList.toggle("is-active", state.answers[key] === value);
        });
        showScreen(0);
      });
    });

    qa("[data-v3-scroll-proof]").forEach(function (button) {
      button.addEventListener("click", function () {
        openBnaStudio(currentBnaCategory || matchedBnaCategory());
      });
    });

    qa("[data-v3-goal]").forEach(function (button) {
      button.addEventListener("click", function () {
        toggleGoal(button.getAttribute("data-v3-goal") || "");
        state.concerns = [];
        state.concern = "";
        setMultiActive("[data-v3-goal]", "data-v3-goal", selectedGoals());
        updateOutcomeVisibility();
        qa("[data-v3-next]").forEach(function (next) {
          next.disabled = !isStepValid(state.screen);
        });
      });
    });

    qa("[data-v3-outcome]").forEach(function (button) {
      button.addEventListener("click", function () {
        toggleConcern(button.getAttribute("data-v3-outcome") || "unsure");
        setMultiActive("[data-v3-outcome]", "data-v3-outcome", selectedConcerns());
        qa("[data-v3-next]").forEach(function (next) {
          next.disabled = !isStepValid(state.screen);
        });
      });
    });

    qa("[data-v3-priority]").forEach(function (button) {
      button.addEventListener("click", function () {
        togglePriority(button.getAttribute("data-v3-priority") || "guided");
        setMultiActive("[data-v3-priority]", "data-v3-priority", selectedPriorities());
        qa("[data-v3-answer-choice='injectables']").forEach(function (btn) {
          btn.classList.toggle("is-active", btn.getAttribute("data-v3-value") === state.answers.injectables);
        });
        qa("[data-v3-next]").forEach(function (next) {
          next.disabled = !isStepValid(state.screen);
        });
      });
    });

    qa("[data-v3-answer]").forEach(function (field) {
      var key = field.getAttribute("data-v3-answer");
      field.addEventListener("input", function () {
        if (key === "bothers") {
          syncBothersFields(field.value || "");
          return;
        }
        state.answers[key] = field.value || "";
      });
    });

    qa("[data-v4-note-chip]").forEach(function (button) {
      button.addEventListener("click", function () {
        var note = button.getAttribute("data-v4-note-chip") || "";
        toggleNotePrompt(note);
      });
    });

    qa("[data-v3-answer-choice]").forEach(function (button) {
      button.addEventListener("click", function () {
        var key = button.getAttribute("data-v3-answer-choice");
        var value = button.getAttribute("data-v3-value") || "";
        if (!key) return;
        state.answers[key] = value;
        qa("[data-v3-answer-choice='" + key + "']").forEach(function (btn) {
          btn.classList.toggle("is-active", btn === button);
        });
      });
    });

    function activateModal(modal) {
      if (!modal) return;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drsknn-v3-lock");
      var close = modal.querySelector("[data-v3-close]");
      if (close && close.focus) setTimeout(function () { close.focus(); }, 30);
    }

    function openModal(name, src) {
      var modal = root.querySelector('[data-v3-modal="' + name + '"]');
      if (!modal) return;
      var iframe = modal.querySelector("iframe");
      if (iframe) {
        if (src) iframe.setAttribute("data-src", src);
        var nextSrc = src || iframe.getAttribute("data-src") || "";
        if (nextSrc && iframe.getAttribute("src") !== nextSrc) iframe.setAttribute("src", nextSrc);
      }
      activateModal(modal);
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      if (!root.querySelector(".drsknn-v3-modal.is-open") && !root.querySelector(".drsknn-v3-review-modal.is-open") && !root.querySelector(".drsknn-v3-proof-modal.is-open")) {
        document.body.classList.remove("drsknn-v3-lock");
      }
    }

    function v4Clean(value, limit) {
      var text = value == null ? "" : String(value);
      text = text.replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim();
      return text.slice(0, limit || 500);
    }

    function v4RoleSlug(value) {
      var role = v4Clean(value, 80).toLowerCase().replace(/_/g, "-");
      if (role === "dr" || role === "doctor-led") return "doctor";
      if (role === "nurse-led") return "nurse";
      if (role === "qp" || role === "qualified" || role === "qualified-practitioner" || role === "qualified_practitioner") return "practitioner";
      if (role === "doctor" || role === "nurse" || role === "practitioner") return role;
      return "";
    }

    function v4ProviderRole(role) {
      if (role === "practitioner") return "qualified_practitioner";
      return role;
    }

    function v4MappedLabels(items, mapper) {
      return (items || []).map(function (item) {
        return v4Clean(mapper ? mapper(item) : item, 80);
      }).filter(Boolean);
    }

    function v4AttributionPayload() {
      var out = {};
      try {
        var params = new URLSearchParams(window.location.search || "");
        [
          "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
          "gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"
        ].forEach(function (key) {
          var value = v4Clean(params.get(key), 255);
          if (value) out[key] = value;
        });
      } catch (_) {}
      return out;
    }

    function v4ConsultationPayload(role) {
      var selectedPath = path();
      var goals = selectedGoals();
      var concerns = selectedConcerns();
      var priorities = selectedPriorities();
      var resultTitleNode = q("[data-v3-result-title]");
      var resultTitle = v4Clean(resultTitleNode ? resultTitleNode.textContent : selectedPath.label, 180);
      var concernLabels = v4MappedLabels(concerns.length ? concerns : ["unsure"], labelForOutcome);
      var goalLabels = v4MappedLabels(goals, labelForGoal);
      var priorityLabels = v4MappedLabels(priorities, function (priority) { return labels[priority] || priority; });
      var note = v4Clean(patientNoteForBooking(), 1800);
      var payload = {
        source: "v4",
        landing_source: "v4_result",
        role: role || "",
        provider_role: v4ProviderRole(role || ""),
        concern: concernLabels.join(", ") || resultTitle || selectedPath.label,
        goals: goalLabels.join(", "),
        priorities: priorityLabels.join(", "),
        result_title: resultTitle,
        route_label: role === "doctor"
          ? "V4 Website Doctor Consultation - Paid"
          : "V4 Website " + (role || "Consultation") + " Consultation - Free",
        patient_note: note,
        selected_clicks: JSON.stringify({
          goals: goals,
          concerns: concerns,
          priorities: priorities,
          answers: state.answers || {},
          result_title: resultTitle
        }),
        source_page: window.location.href
      };
      if (goals[0]) payload.goal = v4Clean(labelForGoal(goals[0]), 120);
      if (priorities[0]) payload.priority = v4Clean(labels[priorities[0]] || priorities[0], 160);
      var attribution = v4AttributionPayload();
      Object.keys(attribution).forEach(function (key) { payload[key] = attribution[key]; });
      return payload;
    }

    function v4ConsultationUrl(role) {
      var slug = v4RoleSlug(role);
      return "https://www.drsknn.uk/kiosk/v4/consultation" + (slug ? "/" + encodeURIComponent(slug) : "");
    }

    function openV4Consultation(role, trigger) {
      var slug = v4RoleSlug(role);
      if (trigger) trigger.setAttribute("aria-busy", "true");
      fetch("https://www.drsknn.uk/api/direct-booking/v4-triage", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(v4ConsultationPayload(slug))
      }).then(function (response) {
        return response.ok ? response.json() : Promise.reject(new Error("triage_failed"));
      }).then(function (json) {
        var url = v4Clean(json && json.url, 2000);
        if (url && url.charAt(0) === "/") url = "https://www.drsknn.uk" + url;
        openModal("kiosk", url || v4ConsultationUrl(slug));
      }).catch(function () {
        openModal("kiosk", v4ConsultationUrl(slug));
      }).finally(function () {
        if (trigger) trigger.removeAttribute("aria-busy");
      });
    }

    qa("[data-v3-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openModal(btn.getAttribute("data-v3-open") || "skin");
      });
    });

    qa("[data-v4-consultation-route]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openV4Consultation(btn.getAttribute("data-v4-consultation-default") || "doctor", btn);
      });
    });

    qa("[data-v3-kiosk]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var tab = btn.getAttribute("data-v3-kiosk") || "consultations";
        openModal("kiosk", "https://www.drsknn.uk/kiosk?tab=" + encodeURIComponent(tab));
      });
    });

    root.addEventListener("click", function (event) {
      var bnaOpen = event.target.closest("[data-v4-bna-open]");
      if (bnaOpen && root.contains(bnaOpen)) {
        event.preventDefault();
        openBnaStudio(bnaOpen.getAttribute("data-v4-bna-category") || currentBnaCategory || matchedBnaCategory());
        return;
      }
      var proofOpen = event.target.closest("[data-v3-proof-index]");
      if (proofOpen && root.contains(proofOpen)) {
        event.preventDefault();
        openProofModal(proofOpen.getAttribute("data-v3-proof-index") || "0", proofOpen);
        return;
      }
      var v4RoleTrigger = event.target.closest("[data-v4-consultation-role]");
      if (v4RoleTrigger && root.contains(v4RoleTrigger)) {
        event.preventDefault();
        openV4Consultation(v4RoleTrigger.getAttribute("data-v4-consultation-role") || "", v4RoleTrigger);
        return;
      }
      var slot = event.target.closest("[data-v3-slot-kiosk]");
      if (!slot || !root.contains(slot)) return;
      event.preventDefault();
      var tab = slot.getAttribute("data-v3-slot-kiosk") || "consultations";
      var slotType = slot.getAttribute("data-v3-slot-type") || "next";
      openModal("kiosk", "https://www.drsknn.uk/kiosk?tab=" + encodeURIComponent(tab));
    });

    var reviewModal = q("[data-v3-review-modal]");
    if (reviewModal) {
      reviewModal.addEventListener("click", function (event) {
        if (event.target.closest("[data-v4-theme-open-pabau]")) {
          event.preventDefault();
          openTrustModal("pabau", event.target);
          return;
        }
        if (event.target === reviewModal || event.target.closest("[data-v3-review-modal-close]")) {
          closeTrustModal();
        }
      });
    }

    var proofModal = q("[data-v3-proof-modal]");
    if (proofModal) {
      proofModal.addEventListener("click", function (event) {
        if (event.target === proofModal || event.target.closest("[data-v3-proof-close]")) {
          closeProofModal();
          return;
        }
        if (event.target.closest("[data-v3-proof-prev]")) {
          moveProofModal(-1);
          return;
        }
        if (event.target.closest("[data-v3-proof-next]")) {
          moveProofModal(1);
        }
      });
    }

    qa("[data-v3-modal]").forEach(function (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal || event.target.closest("[data-v3-close]")) {
          closeModal(modal);
        }
      });
    });

    document.addEventListener("keydown", function (event) {
      if (root.querySelector(".drsknn-v3-proof-modal.is-open")) {
        if (event.key === "ArrowLeft") {
          moveProofModal(-1);
          return;
        }
        if (event.key === "ArrowRight") {
          moveProofModal(1);
          return;
        }
      }
      if (event.key !== "Escape") return;
      closeTrustModal();
      closeProofModal();
      qa(".drsknn-v3-modal.is-open").forEach(closeModal);
    });

    initFluxCanvas();
    initV4HeroProofReel();
    initTrustDocks();
    initPatientThemeRotation();
    relabelGlobalV4Ctas();
    window.setTimeout(relabelGlobalV4Ctas, 500);
    window.addEventListener("load", relabelGlobalV4Ctas);
    ensureGoogleReviewSignals();
    ensurePabauReviewSignals();
    showScreen(0);
  })();
